/* bt-socd-designer.js — уся логіка блока blocks/set-option-cards-v2-designer.liquid
   (картки наборів + попап «Niech zrobi projektant» + події розвилки Fork_*).
   Винесено з блока у вересні 2026: Shopify обмежує Liquid-файл 256 КБ, блок
   був 310 КБ і перестав пушитись (FILE_VALIDATION_ERROR). Код той самий, що
   був inline: `{{ uid }}` став UID, Liquid-json значення — CFG.layout /
   CFG.pixel. Блок кладе [uid, cfg] у window.BtSocdQueue і підключає цей асет
   з defer — черга розбирається тут (порядок defer = порядок у документі, тож
   assets/bt-design-request.js уже визначений). Другий екземпляр блока на
   сторінці додає ще одну пару в чергу; повторне підключення асету — no-op. */
(function () {
  if (window.BtSocdInit) return;
  function init(UID, CFG) {
    CFG = CFG || {};
  (function() {
    var roots = document.querySelectorAll('.soc2-' + UID);
    if (!roots.length) return;
    var root = roots[roots.length - 1];
    var BPC = window.BtPriceConvert;

    var cards = root.querySelectorAll('.soc2__card-' + UID);
    var ctaBtn = root.querySelector('[data-soc2-cta]');

    // Build the CTA href by appending ?qty=N (or &qty=N if the URL already has params)
    // to the configured base URL. This lets the merchant set a base URL like
    // "/products/figure" and we automatically pass which option the user selected.
    function updateCtaHref(qty) {
      if (!ctaBtn) return;
      var base = ctaBtn.getAttribute('data-soc2-base-url') || '';
      var param = ctaBtn.getAttribute('data-soc2-qty-param') || 'qty';
      if (!base || base === '#') {
        // No base URL configured — nothing to update
        return;
      }

      // Strip any existing instance of the qty param so we don't accumulate duplicates
      var url = base;
      var qtyRegex = new RegExp('([?&])' + param + '=[^&]*');
      url = url.replace(qtyRegex, function (m, prefix) {
        // Drop this param entirely; we'll re-append below
        return prefix === '?' ? '?' : '';
      });
      // Clean up trailing/leading separators left behind
      url = url.replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/, '');

      var separator = url.indexOf('?') === -1 ? '?' : '&';
      ctaBtn.setAttribute('href', url + separator + param + '=' + encodeURIComponent(qty));
    }

    function selectCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      // Update CTA href with the selected card's qty value (data-soc2-card="1" / "2" / "3")
      updateCtaHref(card.getAttribute('data-soc2-card'));
    }

    // Initialise href for the default-selected card (so refreshing the page keeps qty in URL)
    var initiallySelected = root.querySelector('.soc2__card-' + UID + '.is-selected');
    if (initiallySelected) {
      updateCtaHref(initiallySelected.getAttribute('data-soc2-card'));
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-soc2-why], [data-soc2-trigger-global]')) return;
        if (card.tagName === 'A' && !card.classList.contains('is-selected')) {
          e.preventDefault();
          selectCard(card);
        } else {
          selectCard(card);
        }
      });
      card.addEventListener('keydown', function (e) {
        if (e.target.closest('[data-soc2-why], [data-soc2-trigger-global]')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (card.tagName === 'A' && card.classList.contains('is-selected')) {
            window.location = card.getAttribute('href');
          } else {
            selectCard(card);
          }
        }
      });
    });

    /* Cache one fetch per API URL to avoid hitting the endpoint on every popover open */
    var __soc2ApiCache = {};
    function fetchPricesOnce(url) {
      if (!url) return Promise.resolve(null);
      if (__soc2ApiCache[url]) return __soc2ApiCache[url];
      __soc2ApiCache[url] = fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      return __soc2ApiCache[url];
    }

    /* Figurine-relevant add-on keys from /prices/ua. Frame-only keys
       (frame13x18, figureInFrame, animal, baby, animalCustomPaint) are
       intentionally excluded — this block is for figurine sets. */
    var FIG_ADDON_KEYS = [
      'photoFrontPrint',
      'photoFace',
      'customFrontPrint',
      'customBackPrint',
      'customHairColor',
      'accessory',
      'carabiner'
    ];

    /* Local-first label dictionary — the prices API sometimes returns
       English descriptions regardless of the endpoint locale, leaving
       the user with the wrong language in the popup. We keep canonical
       translations here and prefer them over `descs[k]`. The API desc
       is only a fallback for keys we haven't translated yet. */
    var SOC2_ADDON_LABELS = {
      it: {
        photoFrontPrint:   'Stampa del busto dalla foto',
        photoFace:         'Viso dalla foto',
        customFrontPrint:  'Stampa personalizzata davanti',
        customBackPrint:   'Stampa personalizzata dietro',
        customHairColor:   'Colore dei capelli personalizzato',
        accessory:         'Accessorio (mani, collo, fianchi)',
        carabiner:         'Moschettone'
      },
      de: {
        photoFrontPrint:   'Oberkörper-Druck nach Foto',
        photoFace:         'Gesicht nach Foto',
        customFrontPrint:  'Individueller Druck vorne',
        customBackPrint:   'Individueller Druck hinten',
        customHairColor:   'Individuelle Haarfarbe',
        accessory:         'Zubehör (Hände, Hals, Hüfte)',
        carabiner:         'Karabiner'
      },
      cs: {
        photoFrontPrint:   'Potisk trupu podle fotky',
        photoFace:         'Obličej podle fotky',
        customFrontPrint:  'Vlastní potisk vpředu',
        customBackPrint:   'Vlastní potisk vzadu',
        customHairColor:   'Vlastní barva vlasů',
        accessory:         'Doplněk (ruce, krk, boky)',
        carabiner:         'Karabina'
      },
      es: {
        photoFrontPrint:   'Estampado del torso a partir de foto',
        photoFace:         'Cara a partir de foto',
        customFrontPrint:  'Estampado personalizado delante',
        customBackPrint:   'Estampado personalizado detrás',
        customHairColor:   'Color de pelo personalizado',
        accessory:         'Accesorio (manos, cuello, cadera)',
        carabiner:         'Mosquetón'
      },
      fr: {
        photoFrontPrint:   'Impression du torse d’après photo',
        photoFace:         'Visage d’après photo',
        customFrontPrint:  'Impression personnalisée devant',
        customBackPrint:   'Impression personnalisée au dos',
        customHairColor:   'Couleur de cheveux personnalisée',
        accessory:         'Accessoire (mains, cou, hanches)',
        carabiner:         'Mousqueton'
      },
      nl: {
        photoFrontPrint:   'Torsoprint naar foto',
        photoFace:         'Gezicht naar foto',
        customFrontPrint:  'Eigen print voorkant',
        customBackPrint:   'Eigen print achterkant',
        customHairColor:   'Eigen haarkleur',
        accessory:         'Accessoire (handen, nek, heupen)',
        carabiner:         'Karabijnhaak'
      },
      sk: {
        photoFrontPrint:   'Potlač trupu podľa fotky',
        photoFace:         'Tvár podľa fotky',
        customFrontPrint:  'Vlastná potlač vpredu',
        customBackPrint:   'Vlastná potlač vzadu',
        customHairColor:   'Vlastná farba vlasov',
        accessory:         'Doplnok (ruky, krk, boky)',
        carabiner:         'Karabína'
      },
      hu: {
        photoFrontPrint:   'Törzsnyomat fotó alapján',
        photoFace:         'Arc fotó alapján',
        customFrontPrint:  'Egyedi nyomat elöl',
        customBackPrint:   'Egyedi nyomat hátul',
        customHairColor:   'Egyedi hajszín',
        accessory:         'Kiegészítő (kéz, nyak, csípő)',
        carabiner:         'Karabiner'
      },
      ro: {
        photoFrontPrint:   'Imprimeu pe tors după poză',
        photoFace:         'Față după poză',
        customFrontPrint:  'Imprimeu personalizat în față',
        customBackPrint:   'Imprimeu personalizat în spate',
        customHairColor:   'Culoare de păr personalizată',
        accessory:         'Accesoriu (mâini, gât, șold)',
        carabiner:         'Carabinieră'
      },
      lt: {
        photoFrontPrint:   'Liemens spauda pagal nuotrauką',
        photoFace:         'Veidas pagal nuotrauką',
        customFrontPrint:  'Individuali spauda priekyje',
        customBackPrint:   'Individuali spauda nugaroje',
        customHairColor:   'Individuali plaukų spalva',
        accessory:         'Aksesuaras (rankos, kaklas, klubai)',
        carabiner:         'Karabinas'
      },
      lv: {
        photoFrontPrint:   'Rumpja apdruka pēc fotogrāfijas',
        photoFace:         'Seja pēc fotogrāfijas',
        customFrontPrint:  'Individuāla apdruka priekšpusē',
        customBackPrint:   'Individuāla apdruka aizmugurē',
        customHairColor:   'Individuāla matu krāsa',
        accessory:         'Aksesuārs (rokas, kakls, gurni)',
        carabiner:         'Karabīne'
      },
      et: {
        photoFrontPrint:   'Torso trükk foto järgi',
        photoFace:         'Nägu foto järgi',
        customFrontPrint:  'Oma trükk eest',
        customBackPrint:   'Oma trükk tagant',
        customHairColor:   'Oma juuksevärv',
        accessory:         'Aksessuaar (käed, kael, puusad)',
        carabiner:         'Karabiin'
      },
      ru: {
        photoFrontPrint:   'Принт торса по фото',
        photoFace:         'Лицо по фото',
        customFrontPrint:  'Индивидуальный принт спереди',
        customBackPrint:   'Индивидуальный принт сзади',
        customHairColor:   'Индивидуальный цвет волос',
        accessory:         'Аксессуар (руки, шея, пояс)',
        carabiner:         'Карабин'
      },
      uk: {
        photoFrontPrint:   'Принт торса з фото',
        photoFace:         'Обличчя з фото',
        customFrontPrint:  'Кастомний принт спереду',
        customBackPrint:   'Кастомний принт ззаду',
        customHairColor:   'Кастомний колір волосся',
        accessory:         'Аксесуар (руки, шия, талія)',
        carabiner:         'Карабін'
      },
      pl: {
        photoFrontPrint:   'Nadruk torsu ze zdjęcia',
        photoFace:         'Twarz ze zdjęcia',
        customFrontPrint:  'Niestandardowy nadruk z przodu',
        customBackPrint:   'Niestandardowy nadruk z tyłu',
        customHairColor:   'Niestandardowy kolor włosów',
        accessory:         'Akcesorium (ręce, szyja, biodra)',
        carabiner:         'Karabińczyk'
      },
      en: {
        photoFrontPrint:   'Torso print from photo',
        photoFace:         'Custom face from photo',
        customFrontPrint:  'Custom front print',
        customBackPrint:   'Custom back print',
        customHairColor:   'Custom hair color',
        accessory:         'Accessory (hands, neck, hips)',
        carabiner:         'Carabiner'
      }
    };
    function soc2DetectLang() {
      var html = document.documentElement;
      var l = (html && html.lang || '').slice(0, 2).toLowerCase();
      if (SOC2_ADDON_LABELS[l]) return l;
      var p = window.location.pathname || '';
      if (p.indexOf('/uk/') !== -1 || p === '/uk') return 'uk';
      if (p.indexOf('/en/') !== -1 || p === '/en') return 'en';
      if (p.indexOf('/it/') !== -1 || p === '/it') return 'it';
      if (p.indexOf('/de/') !== -1 || p === '/de') return 'de';
      if (p.indexOf('/cs/') !== -1 || p === '/cs') return 'cs';
      if (p.indexOf('/es/') !== -1 || p === '/es') return 'es';
      if (p.indexOf('/fr/') !== -1 || p === '/fr') return 'fr';
      if (p.indexOf('/nl/') !== -1 || p === '/nl') return 'nl';
      if (p.indexOf('/sk/') !== -1 || p === '/sk') return 'sk';
      if (p.indexOf('/hu/') !== -1 || p === '/hu') return 'hu';
      if (p.indexOf('/ro/') !== -1 || p === '/ro') return 'ro';
      if (p.indexOf('/lt/') !== -1 || p === '/lt') return 'lt';
      if (p.indexOf('/lv/') !== -1 || p === '/lv') return 'lv';
      if (p.indexOf('/et/') !== -1 || p === '/et') return 'et';
      if (p.indexOf('/ru/') !== -1 || p === '/ru') return 'ru';
      if (p.indexOf('/pl/') !== -1 || p === '/pl') return 'pl';
      return 'uk';  /* UA store default */
    }
    var SOC2_LANG = soc2DetectLang();

    function populatePopoverFromApi(panel) {
      if (!panel || panel.dataset.soc2ApiBreakdown !== '1') return;
      if (panel.__soc2ApiPopulated) return;

      var url = panel.dataset.soc2ApiUrl;
      var sym = panel.dataset.soc2CurrencySuffix || '₴';
      var rowsEl = panel.querySelector('[data-soc2-api-rows]');
      var sectionEl = panel.querySelector('[data-soc2-api-section]');
      var noteEl = panel.querySelector('[data-soc2-api-note]');

      fetchPricesOnce(url).then(function (data) {
        if (!data || !data.success || !data.prices) return;
        var prices = data.prices;
        var descs = data.description || {};

        /* Free quota config (e.g. "перший 1 безкоштовно" under «Аксесуар») */
        function resolveFreeKey(root, p) {
          if (!p || root == null) return null;
          return p.split('.').reduce(function (o, k) { return (o == null) ? null : o[k]; }, root);
        }
        var freeCfg = (function () {
          var configuredPath = panel.dataset.soc2FreePath || '';
          var template = panel.dataset.soc2FreeTmpl || 'перший [N] безкоштовно';
          /* Try configured path first, then common bundle/figurine keys */
          var keys = [configuredPath, 'freeAccessoriesBundle', 'freeAccessoriesPerFigure', 'freeAccessoriesMini', 'freeAccessories'];
          var n = null;
          for (var i = 0; i < keys.length && n == null; i++) {
            var v = resolveFreeKey(data, keys[i]);
            if (v == null) v = resolveFreeKey(prices, keys[i]);
            if (v != null) n = parseInt(v, 10);
          }
          return (n != null && !isNaN(n) && n > 0) ? { count: n, tmpl: template } : null;
        })();

        /* Render only paid figurine add-ons (price > 0). */
        var html = '';
        var rendered = 0;
        var labelDict = SOC2_ADDON_LABELS[SOC2_LANG] || SOC2_ADDON_LABELS.uk || {};
        FIG_ADDON_KEYS.forEach(function (k) {
          if (!prices.hasOwnProperty(k)) return;
          var price = prices[k];
          if (typeof price !== 'number' || price <= 0) return;
          /* Local-first label resolution — prefer our hand-tuned translation
             over the API description (which sometimes returns English text
             even for non-EN endpoints). */
          var label = labelDict[k] || descs[k] || k;
          /* Inject free-quota hint into the accessory row's label */
          var freeHint = '';
          if (k === 'accessory' && freeCfg) {
            freeHint = '<span class="soc2__pop-row-free-' + UID + '">'
                     + freeCfg.tmpl.replace('[N]', String(freeCfg.count)).replace('{N}', String(freeCfg.count))
                     + '</span>';
          }
          html += '<li class="soc2__pop-row-' + UID + '">'
                +   '<span class="soc2__pop-row-label-' + UID + '">' + label + freeHint + '</span>'
                +   '<span class="soc2__pop-row-price-' + UID + '">+' + price + '&nbsp;' + sym + '</span>'
                + '</li>';
          rendered++;
        });
        if (rowsEl) rowsEl.innerHTML = html;
        if (sectionEl) sectionEl.style.display = rendered > 0 ? '' : 'none';

        /* Discount note — uses bundleDiscount{N} where N = figure count. */
        if (noteEl) {
          var figCount = parseInt(panel.dataset.soc2FigureCount, 10);
          var discountKey = 'bundleDiscount' + figCount;
          var discount = prices[discountKey];
          if (typeof discount === 'number' && discount > 0) {
            var template = panel.dataset.soc2DiscountTmpl || 'Знижка -[p]% діє і на додаткові опції';
            noteEl.textContent = '💸 ' + template.replace('[p]', discount);
            noteEl.style.display = 'block';
          } else {
            noteEl.style.display = 'none';
          }
        }
        panel.__soc2ApiPopulated = true;
      });
    }

    function openPopover(idx) {
      var ov = document.querySelector('[data-soc2-pop-overlay="' + idx + '"]');
      var pn = document.querySelector('[data-soc2-pop-panel="' + idx + '"]');
      if (ov) ov.classList.add('is-active');
      if (pn) pn.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      /* Populate API-driven popover content lazily on first open */
      if (pn) populatePopoverFromApi(pn);
    }
    function closePopover(idx) {
      var selOv = idx ? '[data-soc2-pop-overlay="' + idx + '"]' : '[data-soc2-pop-overlay]';
      var selPn = idx ? '[data-soc2-pop-panel="' + idx + '"]'   : '[data-soc2-pop-panel]';
      document.querySelectorAll(selOv).forEach(function (n) { n.classList.remove('is-active'); });
      document.querySelectorAll(selPn).forEach(function (n) { n.classList.remove('is-active'); });
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-soc2-why]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPopover(btn.getAttribute('data-soc2-why'));
      });
    });

    root.querySelectorAll('[data-soc2-trigger-global]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var overlays = document.querySelectorAll('[class*="ai-pop-overlay-"]');
        var panels = document.querySelectorAll('[class*="ai-pop-panel-"]');
        if (!overlays.length && !panels.length) return;

        document.querySelectorAll('[data-soc2-was-hidden]').forEach(function (n) {
          n.style.display = '';
          delete n.dataset.soc2WasHidden;
        });
        if (btn.getAttribute('data-soc2-hide-base') === '1') {
          panels.forEach(function (panel) {
            panel.querySelectorAll('[class*="ai-pop-highlight-"]').forEach(function (hl) {
              hl.dataset.soc2WasHidden = '1';
              hl.style.display = 'none';
            });
          });
        }
        overlays.forEach(function (n) { n.classList.add('is-active'); });
        panels.forEach(function (n) { n.classList.add('is-active'); });
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('[data-soc2-pop-overlay]').forEach(function (ov) {
      ov.addEventListener('click', function () { closePopover(ov.getAttribute('data-soc2-pop-overlay')); });
    });
    document.querySelectorAll('[data-soc2-pop-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closePopover(btn.getAttribute('data-soc2-pop-close')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopover();
    });

    function parsePriceText(s) {
      if (!s) return NaN;
      var clean = s.replace(/[\s ]/g, '');
      var match = clean.match(/[\d.,]+/);
      if (!match) return NaN;
      var num = match[0];
      var hasDot = num.indexOf('.') !== -1;
      var hasComma = num.indexOf(',') !== -1;
      if (hasDot && hasComma) {
        var lastDot = num.lastIndexOf('.');
        var lastComma = num.lastIndexOf(',');
        var decSep = lastDot > lastComma ? '.' : ',';
        var thouSep = decSep === '.' ? ',' : '.';
        num = num.split(thouSep).join('');
        if (decSep === ',') num = num.replace(',', '.');
      } else if (hasComma) {
        var commaIdx = num.lastIndexOf(',');
        var afterComma = num.length - commaIdx - 1;
        if (afterComma === 3 && num.length > 4) num = num.replace(/,/g, '');
        else num = num.replace(',', '.');
      } else if (hasDot) {
        var dotIdx = num.lastIndexOf('.');
        var afterDot = num.length - dotIdx - 1;
        if (afterDot === 3 && num.length > 4) num = num.replace(/\./g, '');
      }
      return parseFloat(num);
    }
    function detectCurrency(s) {
      if (!s) return '';
      var str = String(s);
      /* Якоримось на ОСТАННІЙ цифрі, хвіст лишаємо: ярлик завжди після числа
         ("od 120 zl"). ⚠ НЕ зрізати літери з результату — стара версія їла
         "z" від "zl" → "Oszczednosc 30l". Синхронно з set-option-cards-v2. */
      var m = str.match(/\d\s*([^\d]*)$/);
      var tail = m ? m[1].replace(/[\s.,]/g, '') : '';
      if (tail) return tail;
      /* Nothing after the number — accept a prefix SYMBOL ("$120"), never a
         prefix word, or "od 120" would report its currency as "od". */
      var head = (str.match(/^([^\d]*)\d/) || ['', ''])[1].replace(/[\s.,]/g, '');
      return /[A-Za-zА-Яа-яЁёЇїІіЄєҐґ]/u.test(head) ? '' : head;
    }
    function formatAmount(num) {
      var rounded = Math.round(num * 100) / 100;
      var str = (rounded % 1 === 0) ? rounded.toFixed(0) : rounded.toFixed(2);
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join('.');
    }
    /*
      Конвертація сум, набраних у валюті магазину. Авто-економію добиваємо
      тут окремо: цикл нижче відновлює валютний ярлик, зрізаючи цифри з
      compare-at рядка, а так символ, який ми згенерували, не отримати.
    
    */
    if (BPC && BPC.active) {
      root.querySelectorAll('[data-soc2-money]').forEach(function (el) {
        el.textContent = BPC.text(el.textContent.trim());
      });
      root.querySelectorAll('[data-soc2-savings-auto]').forEach(function (el) {
        var o = parsePriceText(el.getAttribute('data-soc2-old'));
        var n = parsePriceText(el.getAttribute('data-soc2-new'));
        el.removeAttribute('data-soc2-savings-auto');
        if (isNaN(o) || isNaN(n) || o <= n) { el.style.display = 'none'; return; }
        var lbl = el.getAttribute('data-soc2-label') || '';
        /* Різниця двох СКОНВЕРТОВАНИХ цін, а не конвертована різниця: це
           число має сходитись із двома, які покупець бачить очима. */
        var d = BPC.amount(o) - BPC.amount(n);
        el.textContent = (lbl ? lbl + ' ' : '') + BPC.format(d) + ' ' + BPC.symbol;
      });
    }

    root.querySelectorAll('[data-soc2-savings-auto]').forEach(function (el) {
      var oldP = parsePriceText(el.getAttribute('data-soc2-old'));
      var newP = parsePriceText(el.getAttribute('data-soc2-new'));
      if (isNaN(oldP) || isNaN(newP) || oldP <= newP) { el.style.display = 'none'; return; }
      var label = el.getAttribute('data-soc2-label') || '';
      /* Як у гілці вище: різниця двох СКОНВЕРТОВАНИХ цін, а не конвертована
         різниця — число має сходитись із тими, що покупець бачить поруч. */
      if (BPC && BPC.active) {
        el.textContent = (label ? label + ' ' : '') + BPC.format(BPC.amount(oldP) - BPC.amount(newP)) + ' ' + BPC.symbol;
        return;
      }
      var cur = detectCurrency(el.getAttribute('data-soc2-old')) || detectCurrency(el.getAttribute('data-soc2-new')) || '';
      /* Пробіл перед валютою, інакше словесна валюта злипається з числом
         ("30zl"). Так само, як у гілці BPC вище і в set-option-cards-v2. */
      el.textContent = (label ? label + ' ' : '') + formatAmount(oldP - newP) + (cur ? ' ' + cur : '');
    });
    root.querySelectorAll('[data-soc2-discount-auto]').forEach(function (el) {
      var oldP = parsePriceText(el.getAttribute('data-soc2-old'));
      var newP = parsePriceText(el.getAttribute('data-soc2-new'));
      if (isNaN(oldP) || isNaN(newP) || oldP <= newP) { el.style.display = 'none'; return; }
      el.textContent = '-' + Math.round((oldP - newP) / oldP * 100) + '%';
    });
    /* ══ designer path ════════════════════════════════════════════════════ */
    (function initDesigner() {
      var overlay = root.querySelector('[data-socd-overlay]');
      if (!overlay) return;
      var openBtn = root.querySelector('[data-socd-open]');          /* layout A */
      var ctaLink = root.querySelector('[data-soc2-cta]');           /* layout B */
      var LAYOUT  = CFG.layout;
      if (LAYOUT === 'two_buttons' && !openBtn) return;
      if (LAYOUT === 'choice_popup' && !ctaLink) return;

      var curStep = '';
      function showStep(name) {
        curStep = name;
        var steps = overlay.querySelectorAll('[data-socd-step]');
        for (var i = 0; i < steps.length; i++) {
          steps[i].classList.toggle('is-active', steps[i].getAttribute('data-socd-step') === name);
        }
        var modal = overlay.querySelector('.socd__modal-' + UID);
        if (modal) modal.scrollTop = 0;
        overlay.scrollTop = 0;
      }

      var i18nEl = root.querySelector('[data-socd-i18n-' + UID + ']');
      var L = {};
      try { L = JSON.parse(i18nEl.textContent); } catch (e) { L = {}; }
      /* de (12.10.2026): тексти, які блок віддає ЛИШЕ через цей JSON, для німецької
         лежать тут, а не в Liquid — блок упирається в ліміт 256 КБ. У Liquid для de
         база = en плюс гілка `elsif _lx == 'de'` з підписами, що друкуються в HTML. */
      if (SOC2_LANG === 'de') {
        var SOCD_L_DE = {
          mode: 'Design', modeVal: 'Von unserem Designer gestaltet', qty: 'Figuren', keychain: 'Art',
          deadline: 'Termin', occasion: 'Anlass', wishes: 'Wünsche', channel: 'Kontakt',
          figs: 'Figuren im Rahmen', size: 'Rahmengröße', rec: 'empfohlen',
          submitting: 'Wird in den Warenkorb gelegt…',
          propBg: 'Hintergrund', propFcolor: 'Rahmenfarbe', propBrick: 'Farbe der Steine', propSign: 'Text', propCompose: 'Inhalt',
          stepWord: 'Schritt', stepOf: 'von',
          stCompose: 'Wer ist im Set', stFormat: 'Format', stFrame: 'Rahmen', stBg: 'Hintergrund',
          stDeadline: 'Termin', stOccasion: 'Anlass und Wünsche', stContact: 'Kontakt',
          qCompose: 'Wer gehört ins Set?', qComposeF: 'Wer kommt in den Rahmen?',
          tHuman: 'Person', tAnimal: 'Tier', tBaby: 'Baby',
          slotN: 'Figur', slotMain: '(Hauptfigur)', slotIncl: '(im Grundpreis)',
          addFigure: '+ Weitere Figur hinzufügen',
          ladderHave: 'Set-Rabatt schon', ladderNext: 'Die nächste Figur bekommt',
          fromWord: 'ab',
          sizeMax: 'bis zu [N] Figuren', sizeBase: 'Basis',
          sizeWarn: 'In diesen Rahmen passen bis zu [M] Figuren, du hast [N]. Wähle eine größere Größe oder entferne eine Figur.',
          sizeManual: 'Von Hand gewählt. Empfohlen für [N] Figuren: [S].',
          sizeAuto: 'Passend zu deiner Figurenzahl ([N]) gewählt — du kannst es ändern.',
          dlRush: '⚡ Eilig', dlStd: 'Standardlieferzeit',
          dlDate: 'Zu einem Datum', dlDateS: 'nenn uns das Datum — wir richten uns danach', dlDatePick: 'wähle ich selbst',
          dlRelax: 'Keine Eile', dlRelaxS: 'Eilige gehen vor, du bekommst einen Bonus',
          tagPay: 'separat ~', tagFree: 'ohne Aufpreis', tagGift: '🎁 Bonus',
          noteRush: '<b>So funktioniert „Eilig“:</b> Express ist bei uns ein <b>eigener Posten</b> und nicht im Set-Preis enthalten. Du legst das Set wie gewohnt in den Warenkorb, und <b>dort erscheint der Block „Expressversand“</b> mit einem einzigen Button „Hinzufügen“. Für diese Bestellung sind das <b>[F]</b>.<br>Danach rückt deine Bestellung in der Warteschlange nach vorn: Der Designer schreibt dir <b>direkt nach der Bestellung</b>, und die Fotos brauchen wir <b>heute</b>.',
          noteStd: 'Wir versenden <b>[D]</b>. Diesen Termin halten wir wirklich ein: Er wird aus unserer aktuellen Auslastung berechnet und in der Bestellung festgehalten.',
          noteDateRush: 'Dieses Datum liegt vor der Standardlieferzeit — das schaffen wir, aber es ist eine <b>Eilproduktion</b>: Im Warenkorb musst du den „Expressversand“ (<b>[F]</b>) hinzufügen, und die Fotos brauchen wir heute. Wenn <b>[D]</b> auch passt, gibt es keinen Aufpreis.',
          noteDateOk: 'Super — <b>[D]</b> schaffen wir ganz entspannt und ohne Aufpreis. Wir halten dieses Datum in der Bestellung fest.',
          noteRelax: 'Danke! 🙌 Bestellungen wie deine helfen uns, anderen ihr „Brauche ich bis morgen“ zu retten. Dafür <b>legen wir dir eine kleine Überraschung ins Paket</b>. Einen garantierten Termin hast du trotzdem: spätestens <b>[D]</b>.',
          expressNote: '+ „Expressversand“ [F] — im Warenkorb',
          today: 'heute', tomorrow: 'morgen', until: 'bis',
          sumCompose: 'Inhalt des Sets', sumFrame: 'Rahmen', sumBg: 'Hintergrund', sumBrick: 'Steine', sumDisc: 'Rabatt',
          oos: 'ausverkauft', oosWarn: 'Der Rahmen [S] ist in dieser Farbe gerade ausverkauft — wähle eine andere Größe oder Farbe.',
          convNote: 'Preise aus Złoty zum Shop-Kurs umgerechnet — Richtwerte.'
        };
        for (var deKey in SOCD_L_DE) { if (Object.prototype.hasOwnProperty.call(SOCD_L_DE, deKey)) L[deKey] = SOCD_L_DE[deKey]; }
      }
      /* cs/es/fr/nl (01.11.2026) — так само, як de: тут лише тексти, які йдуть через i18n-JSON;
         підписи, що друкуються в HTML, — у snippets/bt-socd-i18n.liquid (база Liquid = en).
         tagGift не перекладаємо: у pl/en він порожній (бонус обіцяє лише de). */
      var SOCD_LX = null;
      if (SOC2_LANG === 'cs') {
        var SOCD_L_CS = {
          mode: 'Návrh',
          modeVal: 'Navrhne náš designér',
          qty: 'Figurky',
          keychain: 'Typ',
          deadline: 'Termín',
          occasion: 'Příležitost',
          wishes: 'Přání',
          channel: 'Kontakt',
          figs: 'Figurky v rámečku',
          size: 'Velikost rámečku',
          rec: 'doporučeno',
          submitting: 'Přidáváme do košíku…',
          propBg: 'Pozadí',
          propFcolor: 'Barva rámečku',
          propBrick: 'Barva kostek',
          propSign: 'Text',
          propCompose: 'Složení',
          stepWord: 'Krok',
          stepOf: 'z',
          stCompose: 'Složení sady',
          stFormat: 'Formát',
          stFrame: 'Rámeček',
          stBg: 'Pozadí',
          stDeadline: 'Termín',
          stOccasion: 'Příležitost a přání',
          stContact: 'Kontakt',
          qCompose: 'Kdo bude v sadě?',
          qComposeF: 'Kdo bude v rámečku?',
          tHuman: 'Člověk',
          tAnimal: 'Zvířátko',
          tBaby: 'Miminko',
          slotN: 'Figurka',
          slotMain: '(hlavní)',
          slotIncl: '(v základní ceně)',
          addFigure: '+ Přidat další figurku',
          ladderHave: 'Sleva na sadu už',
          ladderNext: 'Další figurka dostane slevu',
          fromWord: 'od',
          sizeMax: 'do [N] figurek',
          sizeBase: 'základní',
          sizeWarn: 'Figurek máte [N], tento rámeček pojme nejvýše [M]. Zvolte větší velikost, nebo jednu figurku odeberte.',
          sizeManual: 'Vybráno ručně. Pro tento počet figurek ([N]) doporučujeme [S].',
          sizeAuto: 'Vybráno podle počtu figurek ([N]) — můžete změnit.',
          dlRush: '⚡ Spěchá',
          dlStd: 'Standardní termín',
          dlDate: 'K datu',
          dlDateS: 'zadejte datum — přizpůsobíme se',
          dlDatePick: 'vyberu si',
          dlRelax: 'Nespěchám',
          dlRelaxS: 'garantované datum, bez spěchu',
          tagPay: 'zvlášť ~',
          tagFree: 'bez příplatku',
          noteRush: '<b>Jak funguje „Spěchá“:</b> expres je u nás <b>samostatná položka</b>, není v ceně sady. Sadu přidáte do košíku jako obvykle a <b>v košíku se objeví blok „Expresní odeslání“</b> — stačí jedno kliknutí na „Přidat“. U této objednávky to bude <b>[F]</b>.<br>Potom jde objednávka přednostně: designér vám napíše <b>hned po objednání</b> a fotky je potřeba poslat <b>dnes</b>.',
          noteStd: 'Odešleme <b>[D]</b>. Tento termín opravdu dodržíme: počítá se z naší aktuální vytíženosti a zapíše se do objednávky.',
          noteDateRush: 'Toto datum je dřív než standardní termín — stihneme to, ale jde už o <b>expresní výrobu</b>: v košíku bude potřeba přidat „Expresní odeslání“ (<b>[F]</b>) a fotky budeme potřebovat ještě dnes. Pokud vám vyhovuje <b>[D]</b>, bude to bez příplatku.',
          noteDateOk: 'Skvělé, do <b>[D]</b> to v klidu stihneme, bez příplatku. Datum zapíšeme do objednávky.',
          noteRelax: 'Děkujeme! 🙌 Garantované datum: nejpozději <b>[D]</b>.',
          expressNote: '+ „Expresní odeslání“ [F] — v košíku',
          today: 'dnes',
          tomorrow: 'zítra',
          until: 'do',
          sumCompose: 'Složení sady',
          sumFrame: 'Rámeček',
          sumBg: 'Pozadí',
          sumBrick: 'Kostky',
          sumDisc: 'Sleva',
          oos: 'vyprodáno',
          oosWarn: 'Rámeček [S] v této barvě teď není k dispozici — zvolte jinou velikost nebo barvu.',
          convNote: 'Ceny přepočtené ze zlotých kurzem obchodu — orientační.'
        };
        SOCD_LX = SOCD_L_CS;
      } else if (SOC2_LANG === 'es') {
        var SOCD_L_ES = {
          mode: 'Diseño',
          modeVal: 'Lo diseña nuestro diseñador',
          qty: 'Figuras',
          keychain: 'Tipo',
          deadline: 'Plazo',
          occasion: 'Motivo',
          wishes: 'Detalles',
          channel: 'Contacto',
          figs: 'Figuras en el marco',
          size: 'Tamaño del marco',
          rec: 'recomendado',
          submitting: 'Añadiendo al carrito…',
          propBg: 'Fondo',
          propFcolor: 'Color del marco',
          propBrick: 'Color de las piezas',
          propSign: 'Texto',
          propCompose: 'Composición',
          stepWord: 'Paso',
          stepOf: 'de',
          stCompose: 'Quién va en el set',
          stFormat: 'Formato',
          stFrame: 'Marco',
          stBg: 'Fondo',
          stDeadline: 'Plazo',
          stOccasion: 'Motivo y detalles',
          stContact: 'Contacto',
          qCompose: '¿Quién va en el set?',
          qComposeF: '¿Quién va en el marco?',
          tHuman: 'Persona',
          tAnimal: 'Mascota',
          tBaby: 'Bebé',
          slotN: 'Figura',
          slotMain: '(principal)',
          slotIncl: '(en el precio base)',
          addFigure: '+ Añadir otra figura',
          ladderHave: 'Ya ahorras',
          ladderNext: 'La siguiente figura tiene un descuento de',
          fromWord: 'desde',
          sizeMax: 'hasta [N] figuras',
          sizeBase: 'base',
          sizeWarn: 'En este marco caben hasta [M] figuras y tienes [N]. Elige un tamaño mayor o quita una figura.',
          sizeManual: 'Elegido a mano. Para [N] figuras recomendamos [S].',
          sizeAuto: 'Elegido según el número de figuras ([N]) — puedes cambiarlo.',
          dlRush: '⚡ Urgente',
          dlStd: 'Plazo estándar',
          dlDate: 'Para una fecha',
          dlDateS: 'dinos la fecha — nos adaptamos',
          dlDatePick: 'la elijo yo',
          dlRelax: 'No tengo prisa',
          dlRelaxS: 'fecha garantizada, sin prisas',
          tagPay: 'aparte ~',
          tagFree: 'sin recargo',
          noteRush: '<b>Cómo funciona «Urgente»:</b> el exprés es una <b>partida aparte</b>, no está incluido en el precio del set. Añades el set al carrito como siempre y <b>en el carrito aparecerá el bloque «Envío exprés»</b> — basta un clic en «Añadir». Para este pedido serán <b>[F]</b>.<br>A partir de ahí tu pedido pasa delante: el diseñador te escribe <b>justo después de la compra</b> y necesitamos las fotos <b>hoy</b>.',
          noteStd: 'Lo enviamos <b>[D]</b>. Es un plazo que cumplimos de verdad: se calcula según nuestra carga de trabajo actual y queda fijado en el pedido.',
          noteDateRush: 'Esa fecha es anterior al plazo estándar — llegamos, pero ya es <b>producción urgente</b>: en el carrito tendrás que añadir el «Envío exprés» (<b>[F]</b>) y necesitaremos las fotos hoy. Si te vale <b>[D]</b>, no hay recargo.',
          noteDateOk: 'Genial, para el <b>[D]</b> llegamos sin problema y sin recargo. Dejamos la fecha anotada en el pedido.',
          noteRelax: '¡Gracias! 🙌 Fecha garantizada: como muy tarde el <b>[D]</b>.',
          expressNote: '+ «Envío exprés» [F] — en el carrito',
          today: 'hoy',
          tomorrow: 'mañana',
          until: 'hasta el',
          sumCompose: 'Composición del set',
          sumFrame: 'Marco',
          sumBg: 'Fondo',
          sumBrick: 'Piezas',
          sumDisc: 'Descuento',
          oos: 'agotado',
          oosWarn: 'El marco [S] no está disponible en este color ahora mismo — elige otro tamaño u otro color.',
          convNote: 'Precios convertidos desde złoty al cambio de la tienda — orientativos.'
        };
        SOCD_LX = SOCD_L_ES;
      } else if (SOC2_LANG === 'fr') {
        var SOCD_L_FR = {
          mode: 'Création',
          modeVal: 'Réalisé par notre designer',
          qty: 'Figurines',
          keychain: 'Type',
          deadline: 'Délai',
          occasion: 'Occasion',
          wishes: 'Souhaits',
          channel: 'Contact',
          figs: 'Figurines dans le cadre',
          size: 'Taille du cadre',
          rec: 'recommandé',
          submitting: 'Ajout au panier…',
          propBg: 'Fond',
          propFcolor: 'Couleur du cadre',
          propBrick: 'Couleur des briques',
          propSign: 'Texte',
          propCompose: 'Composition',
          stepWord: 'Étape',
          stepOf: 'sur',
          stCompose: 'Qui est dans le set',
          stFormat: 'Format',
          stFrame: 'Cadre',
          stBg: 'Fond',
          stDeadline: 'Délai',
          stOccasion: 'Occasion et souhaits',
          stContact: 'Contact',
          qCompose: 'Qui sera dans le set ?',
          qComposeF: 'Qui sera dans le cadre ?',
          tHuman: 'Personne',
          tAnimal: 'Animal',
          tBaby: 'Bébé',
          slotN: 'Figurine',
          slotMain: '(principale)',
          slotIncl: '(dans le prix de base)',
          addFigure: '+ Ajouter une figurine',
          ladderHave: 'Vous économisez déjà',
          ladderNext: 'La figurine suivante bénéficie de',
          fromWord: 'dès',
          sizeMax: 'jusqu’à [N] figurines',
          sizeBase: 'de base',
          sizeWarn: 'Ce cadre accueille jusqu’à [M] figurines, vous en avez [N]. Choisissez une taille plus grande ou retirez une figurine.',
          sizeManual: 'Choisi manuellement. Pour [N] figurines, nous recommandons [S].',
          sizeAuto: 'Choisi selon le nombre de figurines ([N]) — modifiable.',
          dlRush: '⚡ Urgent',
          dlStd: 'Délai standard',
          dlDate: 'Pour une date',
          dlDateS: 'indiquez la date — nous nous adaptons',
          dlDatePick: 'je la choisis',
          dlRelax: 'Rien ne presse',
          dlRelaxS: 'date garantie, sans précipitation',
          tagPay: 'en supplément ~',
          tagFree: 'sans supplément',
          noteRush: '<b>Comment fonctionne « Urgent » :</b> l’express est chez nous une <b>ligne à part</b>, il n’est pas compris dans le prix du set. Vous ajoutez le set au panier comme d’habitude, et <b>le panier affiche le bloc « Expédition express »</b> — un seul clic sur « Ajouter ». Pour cette commande, cela fait <b>[F]</b>.<br>Ensuite, votre commande passe en priorité : le designer vous écrit <b>juste après la commande</b>, et il nous faut les photos <b>aujourd’hui</b>.',
          noteStd: 'Nous expédions <b>[D]</b>. C’est un délai que nous tenons vraiment : il est calculé selon notre charge actuelle et fixé dans la commande.',
          noteDateRush: 'Cette date tombe avant le délai standard — c’est faisable, mais c’est une <b>production express</b> : il faudra ajouter l’« Expédition express » au panier (<b>[F]</b>), et il nous faut les photos aujourd’hui. Si <b>[D]</b> vous convient, aucun supplément.',
          noteDateOk: 'Parfait, pour le <b>[D]</b> c’est largement faisable, sans supplément. Nous notons cette date dans la commande.',
          noteRelax: 'Merci ! 🙌 Date garantie : au plus tard le <b>[D]</b>.',
          expressNote: '+ « Expédition express » [F] — dans le panier',
          today: 'aujourd’hui',
          tomorrow: 'demain',
          until: 'd’ici le',
          sumCompose: 'Composition du set',
          sumFrame: 'Cadre',
          sumBg: 'Fond',
          sumBrick: 'Briques',
          sumDisc: 'Remise',
          oos: 'épuisé',
          oosWarn: 'Le cadre [S] est momentanément indisponible dans cette couleur — choisissez une autre taille ou couleur.',
          convNote: 'Prix convertis depuis le złoty au taux de la boutique — à titre indicatif.'
        };
        SOCD_LX = SOCD_L_FR;
      } else if (SOC2_LANG === 'nl') {
        var SOCD_L_NL = {
          mode: 'Ontwerp',
          modeVal: 'Gemaakt door onze ontwerper',
          qty: 'Figuren',
          keychain: 'Type',
          deadline: 'Deadline',
          occasion: 'Gelegenheid',
          wishes: 'Wensen',
          channel: 'Contact',
          figs: 'Figuren in de lijst',
          size: 'Formaat van de lijst',
          rec: 'aanbevolen',
          submitting: 'Wordt aan winkelwagen toegevoegd…',
          propBg: 'Achtergrond',
          propFcolor: 'Kleur van de lijst',
          propBrick: 'Kleur van de steentjes',
          propSign: 'Tekst',
          propCompose: 'Samenstelling',
          stepWord: 'Stap',
          stepOf: 'van',
          stCompose: 'Wie zit er in de set',
          stFormat: 'Formaat',
          stFrame: 'Lijst',
          stBg: 'Achtergrond',
          stDeadline: 'Deadline',
          stOccasion: 'Gelegenheid en wensen',
          stContact: 'Contact',
          qCompose: 'Wie komt er in de set?',
          qComposeF: 'Wie komt er in de lijst?',
          tHuman: 'Persoon',
          tAnimal: 'Huisdier',
          tBaby: 'Baby',
          slotN: 'Figuur',
          slotMain: '(hoofdfiguur)',
          slotIncl: '(in de basisprijs)',
          addFigure: '+ Nog een figuur toevoegen',
          ladderHave: 'Je bespaart al',
          ladderNext: 'De volgende figuur krijgt',
          fromWord: 'vanaf',
          sizeMax: 'tot [N] figuren',
          sizeBase: 'basis',
          sizeWarn: 'In deze lijst passen maximaal [M] figuren, jij hebt er [N]. Kies een groter formaat of verwijder een figuur.',
          sizeManual: 'Handmatig gekozen. Aanbevolen voor [N] figuren: [S].',
          sizeAuto: 'Gekozen op basis van het aantal figuren ([N]) — je kunt het wijzigen.',
          dlRush: '⚡ Spoed',
          dlStd: 'Standaard levertijd',
          dlDate: 'Op een datum',
          dlDateS: 'noem de datum — wij passen ons aan',
          dlDatePick: 'kies ik zelf',
          dlRelax: 'Geen haast',
          dlRelaxS: 'gegarandeerde datum, zonder haast',
          tagPay: 'apart ~',
          tagFree: 'zonder meerprijs',
          noteRush: '<b>Zo werkt "Spoed":</b> spoed is bij ons een <b>aparte post</b> en zit niet in de setprijs. Je legt de set zoals altijd in de winkelwagen, en <b>daar verschijnt het blok "Expresverzending"</b> — één klik op "Toevoegen". Voor deze bestelling is dat <b>[F]</b>.<br>Daarna gaat je bestelling voor: de ontwerper stuurt je <b>direct na de bestelling</b> een bericht en we hebben de foto’s <b>vandaag</b> nodig.',
          noteStd: 'We verzenden <b>[D]</b>. Die termijn halen we echt: hij wordt berekend op basis van onze huidige drukte en vastgelegd in de bestelling.',
          noteDateRush: 'Die datum ligt vóór de standaard levertijd — dat lukt, maar dan is het <b>spoedproductie</b>: je voegt in de winkelwagen "Expresverzending" toe (<b>[F]</b>) en we hebben de foto’s vandaag nodig. Is <b>[D]</b> ook goed, dan betaal je niets extra.',
          noteDateOk: 'Top, <b>[D]</b> halen we rustig en zonder meerprijs. We leggen die datum vast in de bestelling.',
          noteRelax: 'Bedankt! 🙌 Gegarandeerde datum: uiterlijk <b>[D]</b>.',
          expressNote: '+ "Expresverzending" [F] — in de winkelwagen',
          today: 'vandaag',
          tomorrow: 'morgen',
          until: 'uiterlijk',
          sumCompose: 'Inhoud van de set',
          sumFrame: 'Lijst',
          sumBg: 'Achtergrond',
          sumBrick: 'Steentjes',
          sumDisc: 'Korting',
          oos: 'uitverkocht',
          oosWarn: 'De lijst [S] is in deze kleur tijdelijk niet beschikbaar — kies een ander formaat of een andere kleur.',
          convNote: 'Prijzen omgerekend uit złoty tegen de koers van de winkel — indicatief.'
        };
        SOCD_LX = SOCD_L_NL;
      } else if (SOC2_LANG === 'sk') {
        /* sk/hu/ro (друга черга) — ті самі ключі, що cs. */
        var SOCD_L_SK = {
          mode: 'Návrh',
          modeVal: 'Navrhne náš dizajnér',
          qty: 'Figúrky',
          keychain: 'Typ',
          deadline: 'Termín',
          occasion: 'Príležitosť',
          wishes: 'Želania',
          channel: 'Kontakt',
          figs: 'Figúrky v rámiku',
          size: 'Veľkosť rámika',
          rec: 'odporúčané',
          submitting: 'Pridávame do košíka…',
          propBg: 'Pozadie',
          propFcolor: 'Farba rámika',
          propBrick: 'Farba kociek',
          propSign: 'Text',
          propCompose: 'Zloženie',
          stepWord: 'Krok',
          stepOf: 'z',
          stCompose: 'Zloženie sady',
          stFormat: 'Formát',
          stFrame: 'Rámik',
          stBg: 'Pozadie',
          stDeadline: 'Termín',
          stOccasion: 'Príležitosť a želania',
          stContact: 'Kontakt',
          qCompose: 'Kto bude v sade?',
          qComposeF: 'Kto bude v rámiku?',
          tHuman: 'Človek',
          tAnimal: 'Zvieratko',
          tBaby: 'Bábätko',
          slotN: 'Figúrka',
          slotMain: '(hlavná)',
          slotIncl: '(v základnej cene)',
          addFigure: '+ Pridať ďalšiu figúrku',
          ladderHave: 'Zľava na sadu už',
          ladderNext: 'Ďalšia figúrka dostane zľavu',
          fromWord: 'od',
          sizeMax: 'do [N] figúrok',
          sizeBase: 'základná',
          sizeWarn: 'Figúrok máte [N], tento rámik pojme najviac [M]. Zvoľte väčšiu veľkosť alebo jednu figúrku odoberte.',
          sizeManual: 'Vybrané ručne. Pre tento počet figúrok ([N]) odporúčame [S].',
          sizeAuto: 'Vybrané podľa počtu figúrok ([N]) — môžete zmeniť.',
          dlRush: '⚡ Súrne',
          dlStd: 'Štandardný termín',
          dlDate: 'K dátumu',
          dlDateS: 'zadajte dátum — prispôsobíme sa',
          dlDatePick: 'vyberiem si',
          dlRelax: 'Neponáhľam sa',
          dlRelaxS: 'garantovaný dátum, bez náhlenia',
          tagPay: 'zvlášť ~',
          tagFree: 'bez príplatku',
          noteRush: '<b>Ako funguje „Súrne“:</b> expres je u nás <b>samostatná položka</b>, nie je v cene sady. Sadu pridáte do košíka ako zvyčajne a <b>v košíku sa zobrazí blok „Expresné odoslanie“</b> — stačí jedno kliknutie na „Pridať“. Pri tejto objednávke to bude <b>[F]</b>.<br>Potom ide objednávka prednostne: dizajnér vám napíše <b>hneď po objednaní</b> a fotky treba poslať <b>dnes</b>.',
          noteStd: 'Odošleme <b>[D]</b>. Tento termín naozaj dodržíme: počíta sa z nášho aktuálneho vyťaženia a zapíše sa do objednávky.',
          noteDateRush: 'Tento dátum je skôr ako štandardný termín — stihneme to, ale ide už o <b>expresnú výrobu</b>: v košíku bude treba pridať „Expresné odoslanie“ (<b>[F]</b>) a fotky budeme potrebovať ešte dnes. Ak vám vyhovuje <b>[D]</b>, bude to bez príplatku.',
          noteDateOk: 'Výborne, do <b>[D]</b> to v pokoji stihneme, bez príplatku. Dátum zapíšeme do objednávky.',
          noteRelax: 'Ďakujeme! 🙌 Garantovaný dátum: najneskôr <b>[D]</b>.',
          expressNote: '+ „Expresné odoslanie“ [F] — v košíku',
          today: 'dnes',
          tomorrow: 'zajtra',
          until: 'do',
          sumCompose: 'Zloženie sady',
          sumFrame: 'Rámik',
          sumBg: 'Pozadie',
          sumBrick: 'Kocky',
          sumDisc: 'Zľava',
          oos: 'vypredané',
          oosWarn: 'Rámik [S] v tejto farbe teraz nie je k dispozícii — zvoľte inú veľkosť alebo farbu.',
          convNote: 'Ceny prepočítané zo zlotých kurzom obchodu — orientačné.'
        };
        SOCD_LX = SOCD_L_SK;
      } else if (SOC2_LANG === 'hu') {
        var SOCD_L_HU = {
          mode: 'Tervezés',
          modeVal: 'A dizájnerünk készíti el',
          qty: 'Figurák',
          keychain: 'Típus',
          deadline: 'Határidő',
          occasion: 'Alkalom',
          wishes: 'Kívánságok',
          channel: 'Kapcsolat',
          figs: 'Figurák a keretben',
          size: 'Keretméret',
          rec: 'ajánlott',
          submitting: 'Kosárba tesszük…',
          propBg: 'Háttér',
          propFcolor: 'Keret színe',
          propBrick: 'Kockák színe',
          propSign: 'Felirat',
          propCompose: 'Összeállítás',
          stepWord: 'Lépés',
          stepOf: '/',
          stCompose: 'A szett összeállítása',
          stFormat: 'Formátum',
          stFrame: 'Keret',
          stBg: 'Háttér',
          stDeadline: 'Határidő',
          stOccasion: 'Alkalom és kívánságok',
          stContact: 'Kapcsolat',
          qCompose: 'Kik legyenek a szettben?',
          qComposeF: 'Kik legyenek a keretben?',
          tHuman: 'Ember',
          tAnimal: 'Háziállat',
          tBaby: 'Baba',
          slotN: 'Figura',
          slotMain: '(fő)',
          slotIncl: '(benne az alapárban)',
          addFigure: '+ Újabb figura hozzáadása',
          ladderHave: 'Szettkedvezmény eddig:',
          ladderNext: 'A következő figura kedvezménye:',
          fromWord: 'már',
          sizeMax: 'legfeljebb [N] figura',
          sizeBase: 'alap',
          sizeWarn: 'Ebbe a keretbe legfeljebb [M] figura fér, neked [N] van. Válassz nagyobb méretet, vagy vegyél ki egy figurát.',
          sizeManual: 'Kézzel választva. [N] figurához ezt ajánljuk: [S].',
          sizeAuto: 'A figurák száma ([N]) alapján választottuk — megváltoztathatod.',
          dlRush: '⚡ Sürgős',
          dlStd: 'Normál határidő',
          dlDate: 'Adott napra',
          dlDateS: 'add meg a dátumot — alkalmazkodunk',
          dlDatePick: 'kiválasztom',
          dlRelax: 'Nem sürgős',
          dlRelaxS: 'garantált dátum, sietség nélkül',
          tagPay: 'külön ~',
          tagFree: 'felár nélkül',
          noteRush: '<b>Így működik a „Sürgős”:</b> az expressz nálunk <b>külön tétel</b>, nincs benne a szett árában. A szettet a szokásos módon teszed a kosárba, és <b>a kosárban megjelenik az „Expressz szállítás” blokk</b> — ott egy kattintás a „Hozzáadás” gombra. Ennél a rendelésnél ez <b>[F]</b>.<br>Ezután a rendelésed soron kívül halad: a dizájner <b>közvetlenül a rendelés után</b> ír neked, a fotókat pedig <b>még ma</b> el kell küldeni.',
          noteStd: 'Feladjuk: <b>[D]</b>. Ezt a határidőt tényleg tartjuk: a jelenlegi leterheltségünk alapján számoljuk, és rögzítjük a rendelésben.',
          noteDateRush: 'Ez a dátum korábbi a normál határidőnél — megoldjuk, de ez már <b>expressz gyártás</b>: a kosárban hozzá kell adni az „Expressz szállítás” tételt (<b>[F]</b>), a fotókra pedig még ma szükségünk lesz. Ha <b>[D]</b> is megfelel, nincs felár.',
          noteDateOk: 'Szuper, ez a dátum (<b>[D]</b>) kényelmesen belefér, felár nélkül. Rögzítjük a rendelésben.',
          noteRelax: 'Köszönjük! 🙌 Garantált dátum: legkésőbb <b>[D]</b>.',
          expressNote: '+ „Expressz szállítás” [F] — a kosárban',
          today: 'ma',
          tomorrow: 'holnap',
          until: 'legkésőbb',
          sumCompose: 'A szett összeállítása',
          sumFrame: 'Keret',
          sumBg: 'Háttér',
          sumBrick: 'Kockák',
          sumDisc: 'Kedvezmény',
          oos: 'elfogyott',
          oosWarn: 'Ez a keret ([S]) ebben a színben most nem elérhető — válassz másik méretet vagy színt.',
          convNote: 'Az árak zlotyból, a bolt árfolyamán átszámítva — tájékoztató jellegűek.'
        };
        SOCD_LX = SOCD_L_HU;
      } else if (SOC2_LANG === 'ro') {
        var SOCD_L_RO = {
          mode: 'Design',
          modeVal: 'Realizat de designerul nostru',
          qty: 'Figurine',
          keychain: 'Tip',
          deadline: 'Termen',
          occasion: 'Ocazie',
          wishes: 'Dorințe',
          channel: 'Contact',
          figs: 'Figurine în ramă',
          size: 'Mărimea ramei',
          rec: 'recomandat',
          submitting: 'Se adaugă în coș…',
          propBg: 'Fundal',
          propFcolor: 'Culoarea ramei',
          propBrick: 'Culoarea pieselor',
          propSign: 'Text',
          propCompose: 'Componență',
          stepWord: 'Pasul',
          stepOf: 'din',
          stCompose: 'Componența setului',
          stFormat: 'Format',
          stFrame: 'Ramă',
          stBg: 'Fundal',
          stDeadline: 'Termen',
          stOccasion: 'Ocazie și dorințe',
          stContact: 'Contact',
          qCompose: 'Cine va fi în set?',
          qComposeF: 'Cine va fi în ramă?',
          tHuman: 'Om',
          tAnimal: 'Animăluț',
          tBaby: 'Bebeluș',
          slotN: 'Figurina',
          slotMain: '(principală)',
          slotIncl: '(inclusă în prețul de bază)',
          addFigure: '+ Adaugă încă o figurină',
          ladderHave: 'Reducere la set până acum:',
          ladderNext: 'Următoarea figurină primește',
          fromWord: 'de la',
          sizeMax: 'până la [N] figurine',
          sizeBase: 'de bază',
          sizeWarn: 'În această ramă încap cel mult [M] figurine, iar tu ai [N]. Alege o mărime mai mare sau scoate o figurină.',
          sizeManual: 'Ales manual. Pentru [N] figurine recomandăm [S].',
          sizeAuto: 'Ales după numărul de figurine ([N]) — îl poți schimba.',
          dlRush: '⚡ Urgent',
          dlStd: 'Termen standard',
          dlDate: 'La o anumită dată',
          dlDateS: 'spune-ne data — ne adaptăm',
          dlDatePick: 'aleg eu',
          dlRelax: 'Nu mă grăbesc',
          dlRelaxS: 'dată garantată, fără grabă',
          tagPay: 'separat ~',
          tagFree: 'fără cost suplimentar',
          noteRush: '<b>Cum funcționează „Urgent”:</b> la noi expresul este o <b>poziție separată</b>, nu e inclus în prețul setului. Adaugi setul în coș ca de obicei, iar <b>în coș apare blocul „Expediere expres”</b> — acolo un singur clic pe „Adaugă”. Pentru această comandă costă <b>[F]</b>.<br>Apoi comanda ta trece în fața cozii: designerul îți scrie <b>imediat după plasarea comenzii</b>, iar pozele trebuie trimise <b>astăzi</b>.',
          noteStd: 'Expediem <b>[D]</b>. Este un termen pe care chiar îl respectăm: se calculează din încărcarea noastră actuală și se notează în comandă.',
          noteDateRush: 'Această dată este mai devreme decât termenul standard — reușim, dar este deja <b>producție expres</b>: în coș trebuie adăugată „Expediere expres” (<b>[F]</b>), iar pozele ne trebuie chiar azi. Dacă îți convine <b>[D]</b>, va fi fără cost suplimentar.',
          noteDateOk: 'Super, până la <b>[D]</b> reușim liniștiți, fără cost suplimentar. Notăm data în comandă.',
          noteRelax: 'Mulțumim! 🙌 Dată garantată: cel târziu <b>[D]</b>.',
          expressNote: '+ „Expediere expres” [F] — în coș',
          today: 'astăzi',
          tomorrow: 'mâine',
          until: 'până la',
          sumCompose: 'Componența setului',
          sumFrame: 'Ramă',
          sumBg: 'Fundal',
          sumBrick: 'Piese',
          sumDisc: 'Reducere',
          oos: 'stoc epuizat',
          oosWarn: 'Rama [S] în această culoare nu este disponibilă momentan — alege altă mărime sau altă culoare.',
          convNote: 'Prețuri convertite din zloți la cursul magazinului — orientative.'
        };
        SOCD_LX = SOCD_L_RO;
      } else if (SOC2_LANG === 'lt') {
        /* lt/lv/et (третя черга, 02.11) — ті самі ключі, що cs. Назва експресу = товар «Ekspresowa wysyłka» мовою сторінки. */
        var SOCD_L_LT = {
          mode: 'Dizainas',
          modeVal: 'Kuria mūsų dizaineris',
          qty: 'Figūrėlės',
          keychain: 'Tipas',
          deadline: 'Terminas',
          occasion: 'Proga',
          wishes: 'Pageidavimai',
          channel: 'Kontaktas',
          figs: 'Figūrėlės rėmelyje',
          size: 'Rėmelio dydis',
          rec: 'rekomenduojama',
          submitting: 'Dedame į krepšelį…',
          propBg: 'Fonas',
          propFcolor: 'Rėmelio spalva',
          propBrick: 'Kaladėlių spalva',
          propSign: 'Užrašas',
          propCompose: 'Sudėtis',
          stepWord: 'Žingsnis',
          stepOf: 'iš',
          stCompose: 'Rinkinio sudėtis',
          stFormat: 'Formatas',
          stFrame: 'Rėmelis',
          stBg: 'Fonas',
          stDeadline: 'Terminas',
          stOccasion: 'Proga ir pageidavimai',
          stContact: 'Kontaktas',
          qCompose: 'Kas bus rinkinyje?',
          qComposeF: 'Kas bus rėmelyje?',
          tHuman: 'Žmogus',
          tAnimal: 'Gyvūnėlis',
          tBaby: 'Mažylis',
          slotN: 'Figūrėlė',
          slotMain: '(pagrindinė)',
          slotIncl: '(įskaičiuota į bazinę kainą)',
          addFigure: '+ Pridėti dar vieną figūrėlę',
          ladderHave: 'Rinkinio nuolaida jau',
          ladderNext: 'Kita figūrėlė gaus',
          fromWord: 'nuo',
          sizeMax: 'iki [N] figūrėlių',
          sizeBase: 'bazinis',
          sizeWarn: 'Šiame rėmelyje telpa iki [M] figūrėlių, o jūs turite [N]. Pasirinkite didesnį dydį arba pašalinkite figūrėlę.',
          sizeManual: 'Pasirinkta rankiniu būdu. Šiam figūrėlių skaičiui ([N]) rekomenduojame [S].',
          sizeAuto: 'Parinkta pagal figūrėlių skaičių ([N]) — galite pakeisti.',
          dlRush: '⚡ Skubiai',
          dlStd: 'Standartinis terminas',
          dlDate: 'Iki datos',
          dlDateS: 'nurodykite datą — prisitaikysime',
          dlDatePick: 'pasirinksiu pats',
          dlRelax: 'Neskubu',
          dlRelaxS: 'garantuota data, be skubos',
          tagPay: 'atskirai ~',
          tagFree: 'be priemokos',
          noteRush: '<b>Kaip veikia „Skubiai“:</b> skubus užsakymas pas mus yra <b>atskira pozicija</b>, ji neįeina į rinkinio kainą. Rinkinį įdedate į krepšelį kaip įprastai, o <b>krepšelyje atsiras blokas „Skubus išsiuntimas“</b> — ten vienas paspaudimas „Pridėti“. Šiam užsakymui tai bus <b>[F]</b>.<br>Toliau užsakymas eina be eilės: dizaineris parašys <b>iškart po užsakymo</b>, o nuotraukas reikia atsiųsti <b>šiandien</b>.',
          noteStd: 'Išsiųsime <b>[D]</b>. Šio termino tikrai laikomės: jis apskaičiuojamas pagal mūsų dabartinį užimtumą ir įrašomas į užsakymą.',
          noteDateRush: 'Ši data ankstesnė nei standartinis terminas — spėsime, bet tai jau <b>skubi gamyba</b>: krepšelyje reikės pridėti poziciją „Skubus išsiuntimas“ (<b>[F]</b>), o nuotraukų prireiks dar šiandien. Jei tinka <b>[D]</b> — bus be priemokos.',
          noteDateOk: 'Puiku, iki <b>[D]</b> ramiai spėsime, be priemokos. Šią datą įrašysime į užsakymą.',
          noteRelax: 'Ačiū! 🙌 Garantuota data: ne vėliau kaip <b>[D]</b>.',
          expressNote: '+ „Skubus išsiuntimas“ [F] — krepšelyje',
          today: 'šiandien',
          tomorrow: 'rytoj',
          until: 'iki',
          sumCompose: 'Rinkinio sudėtis',
          sumFrame: 'Rėmelis',
          sumBg: 'Fonas',
          sumBrick: 'Kaladėlės',
          sumDisc: 'Nuolaida',
          oos: 'išparduota',
          oosWarn: 'Rėmelio [S] šios spalvos šiuo metu nėra — pasirinkite kitą dydį arba spalvą.',
          convNote: 'Kainos perskaičiuotos iš zlotų pagal parduotuvės kursą — orientacinės.'
        };
        SOCD_LX = SOCD_L_LT;
      } else if (SOC2_LANG === 'lv') {
        var SOCD_L_LV = {
          mode: 'Dizains',
          modeVal: 'Veido mūsu dizainers',
          qty: 'Figūriņas',
          keychain: 'Veids',
          deadline: 'Termiņš',
          occasion: 'Iemesls',
          wishes: 'Vēlmes',
          channel: 'Kontakts',
          figs: 'Figūriņas rāmī',
          size: 'Rāmja izmērs',
          rec: 'ieteicams',
          submitting: 'Pievienojam grozam…',
          propBg: 'Fons',
          propFcolor: 'Rāmja krāsa',
          propBrick: 'Klucīšu krāsa',
          propSign: 'Uzraksts',
          propCompose: 'Sastāvs',
          stepWord: 'Solis',
          stepOf: 'no',
          stCompose: 'Komplekta sastāvs',
          stFormat: 'Formāts',
          stFrame: 'Rāmis',
          stBg: 'Fons',
          stDeadline: 'Termiņš',
          stOccasion: 'Iemesls un vēlmes',
          stContact: 'Kontakts',
          qCompose: 'Kas būs komplektā?',
          qComposeF: 'Kas būs rāmī?',
          tHuman: 'Cilvēks',
          tAnimal: 'Mājdzīvnieks',
          tBaby: 'Mazulis',
          slotN: 'Figūriņa',
          slotMain: '(galvenā)',
          slotIncl: '(iekļauta pamatcenā)',
          addFigure: '+ Pievienot vēl vienu figūriņu',
          ladderHave: 'Komplekta atlaide jau',
          ladderNext: 'Nākamā figūriņa saņems',
          fromWord: 'no',
          sizeMax: 'līdz [N] figūriņām',
          sizeBase: 'pamata',
          sizeWarn: 'Šajā rāmī ietilpst līdz [M] figūriņām, bet tev ir [N]. Izvēlies lielāku izmēru vai noņem kādu figūriņu.',
          sizeManual: 'Izvēlēts manuāli. Šim figūriņu skaitam ([N]) iesakām [S].',
          sizeAuto: 'Izvēlēts pēc figūriņu skaita ([N]) — vari mainīt.',
          dlRush: '⚡ Steidzami',
          dlStd: 'Standarta termiņš',
          dlDate: 'Uz datumu',
          dlDateS: 'norādi datumu — pielāgosimies',
          dlDatePick: 'izvēlēšos pats',
          dlRelax: 'Nesteidzos',
          dlRelaxS: 'garantēts datums, bez steigas',
          tagPay: 'atsevišķi ~',
          tagFree: 'bez piemaksas',
          noteRush: '<b>Kā darbojas „Steidzami“:</b> ekspress pie mums ir <b>atsevišķa pozīcija</b>, tā neietilpst komplekta cenā. Komplektu pievieno grozam kā parasti, un <b>grozā parādīsies bloks „Ekspress nosūtīšana“</b> — tur viens klikšķis uz „Pievienot“. Šim pasūtījumam tas būs <b>[F]</b>.<br>Tālāk pasūtījums iet ārpus rindas: dizainers tev uzrakstīs <b>uzreiz pēc pasūtījuma</b>, un fotogrāfijas jāatsūta <b>šodien</b>.',
          noteStd: 'Nosūtīsim <b>[D]</b>. Šo termiņu mēs tiešām ievērojam: tas tiek aprēķināts pēc mūsu pašreizējās noslodzes un ierakstīts pasūtījumā.',
          noteDateRush: 'Šis datums ir agrāks par standarta termiņu — paspēsim, bet tā jau ir <b>ekspress ražošana</b>: grozā būs jāpievieno „Ekspress nosūtīšana“ (<b>[F]</b>), un fotogrāfijas būs vajadzīgas vēl šodien. Ja der <b>[D]</b> — būs bez piemaksas.',
          noteDateOk: 'Lieliski, līdz <b>[D]</b> mierīgi paspēsim, bez piemaksas. Šo datumu ierakstīsim pasūtījumā.',
          noteRelax: 'Paldies! 🙌 Garantētais datums: ne vēlāk kā <b>[D]</b>.',
          expressNote: '+ „Ekspress nosūtīšana“ [F] — grozā',
          today: 'šodien',
          tomorrow: 'rīt',
          until: 'līdz',
          sumCompose: 'Komplekta sastāvs',
          sumFrame: 'Rāmis',
          sumBg: 'Fons',
          sumBrick: 'Klucīši',
          sumDisc: 'Atlaide',
          oos: 'izpārdots',
          oosWarn: 'Rāmis [S] šajā krāsā pašlaik nav pieejams — izvēlies citu izmēru vai krāsu.',
          convNote: 'Cenas pārrēķinātas no zlotiem pēc veikala kursa — orientējošas.'
        };
        SOCD_LX = SOCD_L_LV;
      } else if (SOC2_LANG === 'et') {
        var SOCD_L_ET = {
          mode: 'Kujundus',
          modeVal: 'Teeb meie disainer',
          qty: 'Kujud',
          keychain: 'Tüüp',
          deadline: 'Tähtaeg',
          occasion: 'Sündmus',
          wishes: 'Soovid',
          channel: 'Kontakt',
          figs: 'Kujud raamis',
          size: 'Raami suurus',
          rec: 'soovitatav',
          submitting: 'Lisame ostukorvi…',
          propBg: 'Taust',
          propFcolor: 'Raami värv',
          propBrick: 'Klotside värv',
          propSign: 'Tekst',
          propCompose: 'Koosseis',
          stepWord: 'Samm',
          stepOf: '/',
          stCompose: 'Komplekti koosseis',
          stFormat: 'Formaat',
          stFrame: 'Raam',
          stBg: 'Taust',
          stDeadline: 'Tähtaeg',
          stOccasion: 'Sündmus ja soovid',
          stContact: 'Kontakt',
          qCompose: 'Kes on komplektis?',
          qComposeF: 'Kes on raamis?',
          tHuman: 'Inimene',
          tAnimal: 'Lemmikloom',
          tBaby: 'Beebi',
          slotN: 'Kuju',
          slotMain: '(peamine)',
          slotIncl: '(baashinna sees)',
          addFigure: '+ Lisa veel üks kuju',
          ladderHave: 'Komplekti allahindlus juba',
          ladderNext: 'Järgmine kuju saab',
          fromWord: 'alates',
          sizeMax: 'kuni [N] kuju',
          sizeBase: 'baas',
          sizeWarn: 'Sellesse raami mahub kuni [M] kuju, sul on [N]. Vali suurem suurus või eemalda üks kuju.',
          sizeManual: 'Valitud käsitsi. Selle kujude arvu ([N]) jaoks soovitame [S].',
          sizeAuto: 'Valitud kujude arvu ([N]) järgi — saad muuta.',
          dlRush: '⚡ Kiire',
          dlStd: 'Tavaline tähtaeg',
          dlDate: 'Kuupäevaks',
          dlDateS: 'anna kuupäev — kohaneme',
          dlDatePick: 'valin ise',
          dlRelax: 'Mul pole kiiret',
          dlRelaxS: 'garanteeritud kuupäev, ilma kiirustamata',
          tagPay: 'eraldi ~',
          tagFree: 'lisatasuta',
          noteRush: '<b>Kuidas töötab „Kiire“:</b> kiirtellimus on meil <b>eraldi rida</b> ega sisaldu komplekti hinnas. Lisad komplekti ostukorvi nagu tavaliselt ja <b>ostukorvis ilmub plokk „Kiirsaatmine“</b> — seal üks klõps nupul „Lisa“. Selle tellimuse puhul on see <b>[F]</b>.<br>Edasi liigub tellimus järjekorrast mööda: disainer kirjutab sulle <b>kohe pärast tellimist</b> ja fotod tuleb saata <b>täna</b>.',
          noteStd: 'Saadame teele <b>[D]</b>. Seda tähtaega me päriselt peame: see arvutatakse meie praeguse koormuse järgi ja märgitakse tellimusse.',
          noteDateRush: 'See kuupäev on varasem kui tavaline tähtaeg — jõuame, aga see on juba <b>kiirtootmine</b>: ostukorvis tuleb lisada „Kiirsaatmine“ (<b>[F]</b>) ja fotosid on vaja juba täna. Kui sobib ka <b>[D]</b>, on see lisatasuta.',
          noteDateOk: 'Suurepärane, kuupäevaks <b>[D]</b> jõuame rahulikult, lisatasuta. Märgime selle kuupäeva tellimusse.',
          noteRelax: 'Aitäh! 🙌 Garanteeritud kuupäev: hiljemalt <b>[D]</b>.',
          expressNote: '+ „Kiirsaatmine“ [F] — ostukorvis',
          today: 'täna',
          tomorrow: 'homme',
          until: 'kuni',
          sumCompose: 'Komplekti koosseis',
          sumFrame: 'Raam',
          sumBg: 'Taust',
          sumBrick: 'Klotsid',
          sumDisc: 'Allahindlus',
          oos: 'otsas',
          oosWarn: 'Raami [S] selles värvis praegu pole — vali teine suurus või värv.',
          convNote: 'Hinnad on zlotidest ümber arvutatud poe kursiga — ligikaudsed.'
        };
        SOCD_LX = SOCD_L_ET;
      }
      if (SOCD_LX) for (var lxKey in SOCD_LX) { if (Object.prototype.hasOwnProperty.call(SOCD_LX, lxKey)) L[lxKey] = SOCD_LX[lxKey]; }

      /* ── Аналітика розвилки: Fork_View / Fork_Kreator / Fork_Projektant /
         Fork_Close (серпень 2026). Приймачі — Meta Pixel + Clarity + Shopify
         analytics (для кастом-пікселя, якщо колись з'явиться).
         ⚠ Піксель каналу Facebook & Instagram працює в пісочниці web pixels:
         window.fbq на сторінці НЕМАЄ. Тому базовий код fbevents вантажимо
         самі — ліниво, при першій події, БЕЗ PageView (стандартні події й
         далі шле канал, дублів нема) і з autoConfig=false (без авто-подій
         кліків по кнопках). Згода — Shopify.customerPrivacy.marketingAllowed;
         Clarity — глобал апп-блоку, є лише після згоди на аналітику.
         Лічильник open_n: події йдуть на КОЖНЕ відкриття модалки; повторне
         відкриття в тій самій сесії видно як open_n > 1 — фільтрувати в
         Events Manager. Fork_Close — лише закриття з екрана вибору (✕ /
         клік повз / Esc); «назад» з брифу і закриття дасть Projektant+Close. */
      var PIXEL_ID = CFG.pixel;
      var forkOpens = 0;
      function marketingAllowed() {
        try {
          var cp = window.Shopify && window.Shopify.customerPrivacy;
          if (cp && typeof cp.marketingAllowed === 'function') return !!cp.marketingAllowed();
        } catch (e) {}
        return true;
      }
      function ensureFbq() {
        if (!PIXEL_ID || !marketingAllowed()) return null;
        if (typeof window.fbq !== 'function') {
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
        }
        if (!window.__socdFbqInit) {
          window.__socdFbqInit = true;
          window.fbq('set', 'autoConfig', false, PIXEL_ID);
          window.fbq('init', PIXEL_ID);
        }
        return window.fbq;
      }
      function track(name, extra) {
        var params = { store: location.hostname, path: location.pathname, open_n: forkOpens };
        for (var k in extra) if (extra.hasOwnProperty(k)) params[k] = extra[k];
        try { var fq = ensureFbq(); if (fq) fq('trackCustom', name, params); } catch (e) {}
        try {
          if (typeof window.clarity === 'function') { window.clarity('event', name); window.clarity('set', 'fork', name); }
        } catch (e) {}
        try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name.toLowerCase(), params);
        } catch (e) {}
      }

      /* Рядок фактів під підзаголовком розвилки. Ціна й поріг доставки —
         у валюті ПОКАЗУ (money() = BtPriceConvert, як картки), строк — з
         delivery-settings складу після відповіді API (до неї 2–3). */
      var factsEl = overlay.querySelector('[data-socd-facts]');
      function parseNum(v) {
        var m = String(v || '').replace(/\s/g, '').replace(',', '.').match(/\d+(\.\d+)?/);
        return m ? parseFloat(m[0]) : NaN;
      }
      function renderFacts() {
        if (!factsEl || !L.facts) return;
        var from = parseNum(L.factsFrom), ship = parseNum(L.factsShip);
        var minD = num(DS && DS.standard_delivery_min_days, 2);
        var maxD = num(DS && DS.standard_delivery_max_days, 3);
        var map = {
          from: isFinite(from) && from > 0 ? money(from) : '',
          d: (minD === maxD) ? String(minD) : (minD + '–' + maxD),
          ship: isFinite(ship) && ship > 0 ? money(ship) : ''
        };
        var segs = String(L.facts).split(' · ').filter(function (seg) {
          var m = seg.match(/\[(\w+)\]/);
          return !m || !!map[m[1]];
        });
        var txt = segs.map(function (seg) { return tpl(seg, map); }).join(' · ');
        /* formatAmount дає «149.90»; польська й українська локалі пишуть
           десятковий роздільник комою («149,90 zł»), англійська — крапкою. */
        if (!/^en/i.test(document.documentElement.lang || '')) txt = txt.replace(/(\d)\.(\d\d)\b/g, '$1,$2');
        factsEl.textContent = txt;
        factsEl.hidden = !txt;
      }

      var dateInput = overlay.querySelector('[data-socd-date]');
      var wishesEl  = overlay.querySelector('[data-socd-wishes]');
      var submitBtn = overlay.querySelector('[data-socd-submit]');
      var errEl     = overlay.querySelector('[data-socd-err]');

      var picked = { qty: null, qtyTitle: '', variant: '', price: '', deadline: null, deadlineLabel: '', occasion: '', channel: '', figCount: 1, figures: null, size: null, sizeLabel: '' };

      /* ══ wizard state ═══════════════════════════════════════════════════
         `slots` is the composition the customer builds on step 1 — the same
         shape the constructor's own set-up screen produces. Everything else
         (totals, cart lines, the brief) is derived from it, so there is one
         source of truth for "who is in this set". */
      var slots = ['human'];
      var wiz = { fcolor: 'black', brick: 'white', bg: null, bgIdea: '', sign: '', occOther: '' };
      var MAX_BY_SIZE = { '13x18': 5, '18x13': 5, '18x18': 8, '25x25': 15, '21x30': 16, '30x21': 16 };
      var HARD_MAX = 16;
      var TYPE_EMOJI = { human: '🧍', animal: '🐾', baby: '👶' };

      /* ── frame brief: price = frame base (by size) + N × figureInFrame −
         tier discount on the figures part. Same maths and same prices API as
         the constructor (config/pricesConfig.ts + store/frame.ts), so the
         popup can never disagree with the builder about money. */
      var FRAME_MODE = submitBtn && submitBtn.getAttribute('data-socd-brief') === 'frame';

      /* «Оплата після макета»: логіка — assets/bt-design-request.js; тут лише
         міст REQX із замиканнями візарда. */
      var REQ_API = submitBtn ? (submitBtn.getAttribute('data-socd-request-api') || '') : '';
      var REQUEST_MODE = !!REQ_API;
      var REQX = null;
      if (REQUEST_MODE) {
        REQX = {
          overlay: overlay, submitBtn: submitBtn, errEl: errEl, L: L,
          api: REQ_API, frameMode: FRAME_MODE, contactEl: null, photos: [],
          state: function () { return { picked: picked, slots: slots, wiz: wiz, framePrices: framePrices }; },
          els: function () { return { dateInput: dateInput, wishesEl: wishesEl, signEl: signEl }; },
          h: { totals: totals, activeSize: activeSize, typePrice: typePrice, composeText: composeText,
               occText: occText, deadlineText: deadlineText, bgText: bgText, swLabel: swLabel,
               parsePriceText: parsePriceText, withRetry: withRetry, reportFailure: reportFailure,
               setBusy: setBusy, fail: fail, showStep: showStep, renderNav: renderNav, paneValid: paneValid }
        };
        (function reqBoot() {
          if (window.BTDesignRequest) { window.BTDesignRequest.init(REQX); }
          else { setTimeout(reqBoot, 120); }
        })();
      }
      var sizeTouched = false;

      /* Преселектимо НАЙМЕНШИЙ розмір, що вміщає композицію.
         ⚠⚠ Перелік розмірів — з каталогу конструктора (/admin/api/public/
         backgrounds, active=TRUE), НЕ з прайс-API: той тримає й вимкнені
         розміри (перша версія пропонувала неіснуючі 21×30/25×25). Фолбек
         без каталогу — консервативні 13×18 і 18×18. */
      var frameSizes = null; /* [{key, max}] у порядку каталогу */
      function fetchBgCatalog() {
        if (!FRAME_MODE || frameSizes) return Promise.resolve(frameSizes);
        var api = L.bgCatalogApi;
        if (!api) return Promise.resolve(null);
        return fetch(api).then(function (r) { return r.json(); }).then(function (list) {
          var out = [], seen = {};
          (Array.isArray(list) ? list : []).forEach(function (c) {
            var fs = String(c.frameSize || c.frame_size || '');
            if (!/^\d+x\d+$/.test(fs)) return;
            var key = fs;
            /* Горизонтальна орієнтація — та сама фізична рамка, повернута
               набік; показуємо її окремою карткою з перевернутим підписом,
               як робить пікер конструктора (13×18 vert + 18×13 horiz). */
            var parts = fs.split('x');
            if ((c.orientation === 'horizontal') && Number(parts[0]) < Number(parts[1])) key = parts[1] + 'x' + parts[0];
            if (seen[key]) return;
            seen[key] = true;
            var mf = Number(c.maxFigures || c.max_figures);
            out.push({ key: key, max: (isFinite(mf) && mf > 0) ? mf : (MAX_BY_SIZE[key] || 5) });
          });
          if (out.length) frameSizes = out;
          renderAll();
          return frameSizes;
        }).catch(function () { return null; });
      }
      function sizeEntries() {
        var src = frameSizes || [{ key: '13x18', max: MAX_BY_SIZE['13x18'] }, { key: '18x18', max: MAX_BY_SIZE['18x18'] }];
        /* Розмір продається, лише якщо на нього є ціна. */
        var out = [];
        for (var i = 0; i < src.length; i++) if (framePrices && apiNum(priceKeyOf(src[i].key))) out.push(src[i]);
        out.sort(function (a, b) { return a.max - b.max || (apiNum(priceKeyOf(a.key)) - apiNum(priceKeyOf(b.key))); });
        return out;
      }

      /* ── наявність рамки конкретного кольору: фід конструктора
         (/inventory/availability), SKU FRAME-{COLOR}-{W}-{H}; горизонтальна
         орієнтація ділить SKU з вертикальною. Фід null → все доступне:
         збій складу не зупиняє продаж, дизайнер переуточнить. */
      var INV = null, invLoaded = false;
      function fetchInventory() {
        if (!FRAME_MODE || invLoaded) return Promise.resolve(INV);
        var api = submitBtn.getAttribute('data-socd-prices-api');
        if (!api) return Promise.resolve(null);
        var host = api.split('/prices/')[0];
        return fetch(host + '/inventory/availability').then(function (r) { return r.json(); }).then(function (d) {
          var list = (d && d.products) || [];
          if (list.length) {
            INV = {};
            for (var i = 0; i < list.length; i++) INV[String(list[i].sku || '')] = list[i];
          }
          invLoaded = true;
          pickAvailableFrameColor();
          renderAll();
          return INV;
        }).catch(function () { invLoaded = true; return null; });
      }
      /* Дефолтний колір рамки може бути повністю розпроданий (на PL станом на
         15.08 чорних немає жодного розміру) — тоді перший же екран рамки
         відкривався заблокованим. Мовчки беремо колір, який Є, поки покупець
         не обрав колір сам. Дзеркало getFirstAvailableFrame у конструкторі:
         спершу тримаємось розміру, міняємо лише колір. */
      var fcolorTouched = false;
      function pickAvailableFrameColor() {
        if (!FRAME_MODE || fcolorTouched || !INV) return;
        var sz = activeSize();
        if (!sz || frameInStock(sz, wiz.fcolor)) return;
        var alts = ['black', 'white'], i;
        for (i = 0; i < alts.length; i++) {
          if (alts[i] !== wiz.fcolor && frameInStock(sz, alts[i])) {
            wiz.fcolor = alts[i];
            markSwatch('fcolor', wiz.fcolor);
            return;
          }
        }
      }
      function frameSkuOf(sizeKey, color) {
        var p = sizeKey.split('x');
        /* горизонтальний ключ → вертикальний SKU (та сама рамка боком) */
        if (Number(p[0]) > Number(p[1])) p = [p[1], p[0]];
        return 'FRAME-' + String(color || 'black').toUpperCase() + '-' + p[0] + '-' + p[1];
      }
      function frameInStock(sizeKey, color) {
        if (!INV) return true;
        var prod = INV[frameSkuOf(sizeKey, color)];
        if (!prod) return true; /* SKU не відстежується складом — не блокуємо */
        if (prod.available_to_order !== true) return false;
        if (typeof prod.free_to_order === 'number') return prod.free_to_order > 0;
        return Number(prod.available_for_order) > 0;
      }
      /* '18x13' — це повернута 13x18: ціна одна. */
      function priceKeyOf(key) {
        if (framePrices && Number(framePrices['frame' + key]) > 0) return 'frame' + key;
        var p = key.split('x');
        return 'frame' + p[1] + 'x' + p[0];
      }
      function sizeMax(key) {
        var list = sizeEntries();
        for (var i = 0; i < list.length; i++) if (list[i].key === key) return list[i].max;
        return MAX_BY_SIZE[key] || 5;
      }
      function recommendedSize() {
        var order = sizeEntries(), n = slots.length, i;
        /* Спершу — найменша рамка, яка і вміщує, і Є НА СКЛАДІ в обраному
           кольорі; якщо такої немає — найменша, яка просто вміщує. */
        for (i = 0; i < order.length; i++)
          if (order[i].max >= n && frameInStock(order[i].key, wiz.fcolor)) return order[i].key;
        for (i = 0; i < order.length; i++) if (order[i].max >= n) return order[i].key;
        return order.length ? order[order.length - 1].key : null;
      }
      function activeSize() { return picked.size || recommendedSize(); }

      var framePrices = null;
      /* Прайс потрібен обом режимам: рамці — щоб порахувати суму, фігуркам —
         щоб узяти БАЗОВУ ціну однієї фігурки. Він же приносить ПРАПОРЦІ
         НАЯВНОСТІ (bundleBabyEnabled / frameBabyEnabled) — тобто що саме
         показувати у виборі типів. Нічого з цього в темі не зашито. */
      function fetchFramePrices() {
        if (framePrices) return Promise.resolve(framePrices);
        var api = submitBtn.getAttribute('data-socd-prices-api');
        return fetch(api).then(function (r) { return r.json(); }).then(function (d) {
          framePrices = d && (d.prices || d);
          renderAll();
          return framePrices;
        }).catch(function () { return null; });
      }
      function apiNum(k) {
        var v = framePrices && Number(framePrices[k]);
        return (isFinite(v) && v > 0) ? v : null;
      }
      function baseFigurePrice() { return apiNum('figure'); }

      /* Ціна одного слота за типом. У рамці людина коштує figureInFrame, а не
         повну figure — саме так рахує конструктор рамки. */
      function typePrice(t) {
        if (t === 'human') return FRAME_MODE ? apiNum('figureInFrame') : apiNum('figure');
        if (t === 'animal') return apiNum('animal');
        if (t === 'baby') return apiNum('baby');
        return null;
      }
      /* Наявність типу = є ціна в API (+ окремий тумблер для малюка). */
      function typeAvailable(t) {
        if (!framePrices) return t === 'human';
        if (t === 'baby') {
          var flag = Number(framePrices[FRAME_MODE ? 'frameBabyEnabled' : 'bundleBabyEnabled']);
          if (flag !== 1) return false;
        }
        return typePrice(t) != null;
      }
      function availableTypes() {
        var all = ['human', 'animal', 'baby'], out = [];
        for (var i = 0; i < all.length; i++) if (typeAvailable(all[i])) out.push(all[i]);
        return out.length ? out : ['human'];
      }

      /* ── знижки ────────────────────────────────────────────────────────────
         Набір: модель автоматичних знижок Shopify (та сама, що в конструкторі,
         config/pricesConfig.ts) — блоки повторюються, неповний блок не рахується,
         діє ОДНЕ найвигідніше правило, і лягає воно на НАЙДЕШЕВШІ позиції.
         Рамка: тірний % від суми фігурок. Обидва набори відсотків — з API. */
      function bundleRules() {
        var r = [];
        var d2 = Number(framePrices && framePrices.bundleDiscount2) || 0;
        var d3 = Number(framePrices && framePrices.bundleDiscount3) || 0;
        var d5 = Number(framePrices && framePrices.bundleDiscount5) || 0;
        if (d2 > 0) r.push({ block: 2, get: 1, pct: d2 });
        if (d3 > 0) { r.push({ block: 3, get: 2, pct: d3 }); r.push({ block: 4, get: 3, pct: d3 }); }
        if (d5 > 0) { r.push({ block: 5, get: 4, pct: d5 }); r.push({ block: 6, get: 5, pct: d5 }); }
        return r;
      }
      function bundleDiscount(prices) {
        var n = prices.length, empty = { total: 0, pct: 0 };
        if (n < 2) return empty;
        var order = [], i;
        for (i = 0; i < n; i++) order.push(i);
        order.sort(function (a, b) { return (prices[a] - prices[b]) || (b - a); });
        var rules = bundleRules(), best = empty;
        for (i = 0; i < rules.length; i++) {
          var m = Math.floor(n / rules[i].block) * rules[i].get;
          if (m <= 0) continue;
          var total = 0;
          for (var k = 0; k < m; k++) total += Math.round(prices[order[k]] * rules[i].pct) / 100;
          if (total > best.total) best = { total: total, pct: rules[i].pct };
        }
        return best;
      }
      function frameDiscountPct(n) {
        var tiers = [[15, 'frameDiscount15'], [10, 'frameDiscount10'], [6, 'frameDiscount6'], [4, 'frameDiscount4'], [2, 'frameDiscount2']];
        for (var i = 0; i < tiers.length; i++) {
          if (n >= tiers[i][0]) {
            var p = Number(framePrices && framePrices[tiers[i][1]]) || 0;
            if (p > 0) return p;
          }
        }
        return 0;
      }
      /* Маржинальний % для бейджа на позиції — як getBundleDiscountPercentForPosition. */
      function bundlePctForPosition(pos) {
        var base = typePrice('human');
        if (!base) return 0;
        var before = [], i;
        for (i = 0; i < pos - 1; i++) before.push(base);
        var after = before.slice(); after.push(base);
        var res = bundleDiscount(after);
        var delta = res.total - bundleDiscount(before).total;
        if (delta <= 0) return 0;
        return Math.min(res.pct, Math.round(delta / base * 100));
      }
      function slotDiscountPct(pos) {
        return FRAME_MODE ? frameDiscountPct(slots.length) : bundlePctForPosition(pos);
      }

      function slotPrices() {
        var out = [];
        for (var i = 0; i < slots.length; i++) out.push(typePrice(slots[i]) || 0);
        return out;
      }
      /* Підсумок. Рамка: рамка + фігурки − тірна знижка. Набір: сума фігурок
         − драбина Shopify (кошик порахує так само, бо модель одна). */
      function totals() {
        var p = slotPrices(), i, figSub = 0;
        for (i = 0; i < p.length; i++) figSub += p[i];
        if (FRAME_MODE) {
          var sz = activeSize();
          var frame = sz ? (apiNum(priceKeyOf(sz)) || 0) : 0;
          var save = Math.round(figSub * frameDiscountPct(slots.length) / 100);
          return { full: frame + figSub, save: save, total: frame + figSub - save, frame: frame };
        }
        var d = Math.round(bundleDiscount(p).total);
        return { full: figSub, save: d, total: figSub - d, frame: 0 };
      }

      /* ── строки виготовлення ───────────────────────────────────────────────
         Живий графік складу: `schedule.days` каже, які дні реально робочі
         (вихідні, свята, зміни). Без нього — фолбек на будні. */
      var DS = null, DSDAY = {};
      function isoOf(d) {
        return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      }
      function fetchDelivery() {
        var api = L.deliveryApi;
        if (!api) return Promise.resolve(null);
        return fetch(api).then(function (r) { return r.json(); }).then(function (d) {
          DS = (d && d.settings) ? d.settings : d;
          var days = DS && DS.schedule && DS.schedule.days;
          if (days && days.length) for (var i = 0; i < days.length; i++) DSDAY[days[i].date] = !!days[i].is_working;
          renderAll();
          return DS;
        }).catch(function () { return null; });
      }
      function isWorkDay(d) {
        var iso = isoOf(d);
        if (DSDAY.hasOwnProperty(iso)) return DSDAY[iso];
        if (DS && DS.works_on_weekends) return true;
        var w = d.getDay();
        return w !== 0 && w !== 6;
      }
      function addWorkDays(from, n) {
        var d = new Date(from.getTime()), guard = 0;
        while (n > 0 && guard++ < 400) { d.setDate(d.getDate() + 1); if (isWorkDay(d)) n--; }
        return d;
      }
      function num(v, dflt) { var x = Number(v); return isFinite(x) ? x : dflt; }
      function computeDates() {
        var now = new Date(), rush;
        var cutoff = num(DS && DS.same_day_cutoff_hour, 12);
        if (DS && DS.same_day_enabled && isWorkDay(now) && now.getHours() < cutoff) rush = new Date(now.getTime());
        else rush = addWorkDays(now, 1);
        var minD = num(DS && DS.standard_delivery_min_days, 2);
        var maxD = num(DS && DS.standard_delivery_max_days, 4);
        return {
          rush: rush,
          stdFrom: addWorkDays(now, minD),
          stdTo: addWorkDays(now, maxD),
          relaxMax: addWorkDays(now, maxD + 3)
        };
      }
      function fmtD(d) {
        return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2);
      }
      function stdRange() { var c = computeDates(); return fmtD(c.stdFrom) + '–' + fmtD(c.stdTo); }

      /* ⚠ Терміновість — це ОКРЕМИЙ товар «Швидка відправка», який покупець
         додає вже в КОШИКУ (FastDeliverySystem у blocks/_cart-summary.liquid),
         а не доплата всередині цієї лінії. Тут рахуємо лише орієнтовну суму —
         тією самою формулою і тією самою тарифною сіткою, щоб людина побачила
         в кошику рівно те число, яке ми назвали. */
      var EXPRESS_TIERS = String(L.expressTiers || '').split(',').map(Number).filter(function (n) { return n > 0; });
      if (!EXPRESS_TIERS.length) EXPRESS_TIERS = [75, 99, 124, 149, 174, 199, 224, 249, 274, 299, 324, 349, 374, 399, 424, 449];
      function expressFee(cartTotal) {
        var raw, i;
        if (DS && DS.express_paid === true && typeof DS.express_price_value === 'number') {
          if ((DS.express_price_type || 'percent') === 'fixed') raw = Math.max(1, Math.round(DS.express_price_value));
          else {
            raw = Math.floor(cartTotal * DS.express_price_value / 100);
            if (DS.express_price_type === 'percent_capped' && Number(DS.express_price_max) > 0) raw = Math.min(raw, Math.round(DS.express_price_max));
            raw = Math.max(1, raw);
          }
        } else {
          var lo = EXPRESS_TIERS[0], hi = EXPRESS_TIERS[EXPRESS_TIERS.length - 1];
          raw = Math.min(hi, Math.max(lo, Math.floor(cartTotal * 0.15)));
        }
        /* PL бере НАЙБЛИЖЧИЙ щабель у будь-який бік, UA — найближчий ВГОРУ. */
        if (L.expressPick === 'near') {
          var best = EXPRESS_TIERS[0];
          for (i = 0; i < EXPRESS_TIERS.length; i++) {
            if (Math.abs(EXPRESS_TIERS[i] - raw) < Math.abs(best - raw)) best = EXPRESS_TIERS[i];
          }
          return best;
        }
        for (i = 0; i < EXPRESS_TIERS.length; i++) if (raw <= EXPRESS_TIERS[i]) return EXPRESS_TIERS[i];
        return EXPRESS_TIERS[EXPRESS_TIERS.length - 1];
      }
      function cur() { return submitBtn.getAttribute('data-socd-cur') || ''; }
      /* Суми візарда живуть у валюті магазину (prices API + налаштування) і
         Shopify їх не бачить — конвертуємо на показі, як картки вище. Оплата
         НЕ звідси: cartLines шукає варіант за злотовою сумою, її не чіпаємо.
         Для рамки конвертований підсумок точний (один варіант — Shopify
         округлює саме його); складові й набори — орієнтовні, про це
         L.convNote у брейкдауні. */
      function money(v) { return BPC && BPC.active ? BPC.money(v) : formatAmount(v) + ' ' + cur(); }
      function tpl(s, map) {
        s = String(s || '');
        for (var k in map) if (map.hasOwnProperty(k)) s = s.split('[' + k + ']').join(map[k]);
        return s;
      }
      /* Раніше в кошик летів варіант за ціною КАРТКИ (2100 за дві) одним рядком:
         Shopify бачив один товар, автознижка за кількість не вмикалась, а сума
         була зашита в назву варіанта. Тепер кладемо N базових фігурок і знижку
         рахує кошик — так само, як для збірок із конструктора. Тому й показуємо
         суму ДО знижки з поясненням, а не готовий підсумок. */
      /* ── рендер ────────────────────────────────────────────────────────── */
      var elSlots   = overlay.querySelector('[data-socd-slots]');
      var elAddSlot = overlay.querySelector('[data-socd-addslot]');
      var elLadder  = overlay.querySelector('[data-socd-ladder]');
      var elSizes   = overlay.querySelector('[data-socd-sizes]');
      var elSizeWarn= overlay.querySelector('[data-socd-sizewarn]');
      var elDl      = overlay.querySelector('[data-socd-dl]');
      var elDlNote  = overlay.querySelector('[data-socd-dlnote]');
      var elSummary = overlay.querySelector('[data-socd-summary]');
      var elProg    = overlay.querySelector('[data-socd-prog]');
      var elStepNo  = overlay.querySelector('[data-socd-stepno]');
      var elStepNm  = overlay.querySelector('[data-socd-stepname]');
      var elCrumbs  = overlay.querySelector('[data-socd-crumbs]');
      var nextBtn   = overlay.querySelector('[data-socd-next]');
      var prevBtn   = overlay.querySelector('[data-socd-prev]');
      var skipBtn   = overlay.querySelector('[data-socd-skip]');
      var bgIdeaEl  = overlay.querySelector('[data-socd-bgidea]');
      var occOtherEl= overlay.querySelector('[data-socd-occ-other]');
      var signEl    = overlay.querySelector('[data-socd-sign]');

      var PANES = [];
      (function () {
        var list = overlay.querySelectorAll('[data-socd-w]');
        for (var i = 0; i < list.length; i++) PANES.push(list[i].getAttribute('data-socd-w'));
      })();
      var PANE_NAME = {
        compose: FRAME_MODE ? (L.stCompose || '') : (L.stCompose || ''),
        format: L.stFormat || '', frame: L.stFrame || '', bg: L.stBg || '',
        deadline: L.stDeadline || '', occasion: L.stOccasion || '', contact: L.stContact || ''
      };
      var cur_ = 0;
      /* offer_mode (є слот [data-po-price-slot] блока bt-photo-offer): кроки показуються групами —
         «хто / формат / рамка й фон» · «коли / привід» · «контакт і фото» — 3 екрани замість 5–6.
         cur_ і далі — індекс панелі; екран = група, в якій вона лежить. */
      var GROUPS = null;
      if (document.querySelector('[data-po-price-slot]')) {
        var gA = [], gB = [], gC = [];
        for (var gi = 0; gi < PANES.length; gi++) {
          var gp = PANES[gi];
          if (gp === 'deadline' || gp === 'occasion') gB.push(gi);
          else if (gp === 'contact') gC.push(gi);
          else gA.push(gi);
        }
        GROUPS = [gA, gB, gC].filter(function (g) { return g.length; });
        overlay.classList.add('po-offer');
      }
      function scrIdx(i) { if (!GROUPS) return i; for (var g = 0; g < GROUPS.length; g++) if (GROUPS[g].indexOf(i) >= 0) return g; return 0; }
      function scr(i) { return GROUPS ? GROUPS[scrIdx(i)] : [i]; }
      function pane() { return PANES[cur_]; }
      function isLast() { return GROUPS ? scrIdx(cur_) === GROUPS.length - 1 : cur_ === PANES.length - 1; }
      function stepTo(dir) { if (!GROUPS) return cur_ + dir; var g = GROUPS[scrIdx(cur_) + dir]; return g ? g[0] : cur_; }

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
          return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
        });
      }
      function typeLabel(t) { return t === 'human' ? (L.tHuman || 'Human') : t === 'animal' ? (L.tAnimal || 'Pet') : (L.tBaby || 'Baby'); }
      function typeImg(t) { return (L.typeImages && L.typeImages[t]) || ''; }

      /* img з падінням в емодзі: асет можуть не залити (нова тема, PL-копія) —
         битих іконок покупець бачити не повинен. */
      function typeImgHtml(t, px) {
        var img = typeImg(t);
        var emoji = '<span style="font-size:' + Math.round(px * 0.75) + 'px;line-height:' + px + 'px' + (img ? ';display:none' : '') + '">' + TYPE_EMOJI[t] + '</span>';
        if (!img) return emoji;
        return '<img src="' + esc(img) + '" alt="" style="width:' + px + 'px;height:' + px + 'px;object-fit:contain" ' +
               'onerror="this.style.display=\'none\';if(this.nextElementSibling)this.nextElementSibling.style.display=\'\'">' + emoji;
      }

      function renderSlots() {
        if (!elSlots) return;
        var types = availableTypes(), html = '', i;
        for (i = 0; i < slots.length; i++) {
          var fixed = i === 0;
          var pct = slotDiscountPct(i + 1);
          if (fixed) {
            /* Слот 0 без вибору — тонкий рядок замість картки на пів екрана. */
            html += '<div class="socd__slotfixed-' + UID + '">' + typeImgHtml('human', 30) +
                    '<span class="nm">' + esc(L.slotN || 'Figure') + ' 1 · ' + esc(typeLabel('human')) + '</span>' +
                    '<span class="in">' + esc(FRAME_MODE ? (L.slotIncl || '') : (L.slotMain || '')) + '</span></div>';
            continue;
          }
          html += '<div class="socd__slot-' + UID + '"><div class="socd__slothead-' + UID + '">';
          html += '<div class="socd__slotn-' + UID + '">' + esc(L.slotN || 'Figure') + ' ' + (i + 1) + '</div>';
          html += '<div class="socd__slotright-' + UID + '">';
          if (pct > 0) html += '<span class="socd__slotdisc-' + UID + '">−' + pct + '%</span>';
          html += '<button type="button" class="socd__slotrm-' + UID + '" data-socd-slotrm="' + i + '">✕</button>';
          html += '</div></div>';
          html += '<div class="socd__types-' + UID + '" style="grid-template-columns:repeat(' + types.length + ',minmax(0,1fr))">';
          for (var j = 0; j < types.length; j++) {
            var t = types[j], full = typePrice(t), save = full ? Math.round(full * pct / 100) : 0, fin = full ? full - save : null;
            html += '<button type="button" class="socd__type-' + UID + '' + (slots[i] === t ? ' is-on' : '') + '"' +
                    ' data-socd-slotset="' + i + '|' + t + '">';
            html += typeImgHtml(t, 34);
            html += '<span class="socd__typenm-' + UID + '">' + esc(typeLabel(t)) + '</span>';
            if (full == null) html += '<span class="socd__typepr-' + UID + '">—</span>';
            else if (pct > 0) html += '<span class="socd__typepr-' + UID + '"><b>' + money(fin) + '</b><s>' + money(full) + '</s></span>';
            else html += '<span class="socd__typepr-' + UID + '">' + (FRAME_MODE ? '' : esc(L.fromWord || '') + ' ') + money(full) + '</span>';
            html += '</button>';
          }
          html += '</div></div>';
        }
        elSlots.innerHTML = html;

        var q = overlay.querySelector('[data-socd-compose-q]');
        if (q) q.innerHTML = esc(FRAME_MODE ? (L.qComposeF || '') : (L.qCompose || '')) +
          ' <span>' + esc(L.composeHint || '') + '</span>';
        if (elAddSlot) {
          elAddSlot.textContent = L.addFigure || '+';
          /* Рамка: стеля = найбільша рамка, яка ЗАРАЗ продається (з каталогу),
             а не теоретичний максимум — інакше пропонуємо додати 9-ту фігурку,
             коли найбільша доступна рамка вміщує 8. */
          var lim = 12;
          if (FRAME_MODE) {
            var es = sizeEntries(), m = 0;
            for (var q2 = 0; q2 < es.length; q2++) if (es[q2].max > m) m = es[q2].max;
            lim = m || HARD_MAX;
          }
          if (slots.length >= lim) elAddSlot.setAttribute('disabled', 'disabled');
          else elAddSlot.removeAttribute('disabled');
        }
        if (elLadder) {
          var t2 = totals(), parts = [];
          if (t2.save > 0) parts.push(esc(L.ladderHave || '') + ' <b>−' + money(t2.save) + '</b>.');
          if (!FRAME_MODE) {
            var nx = bundlePctForPosition(slots.length + 1);
            if (nx > 0) parts.push(esc(L.ladderNext || '') + ' <b>−' + nx + '%</b>.');
          } else {
            var rec = recommendedSize();
            if (rec) parts.push(esc(tpl(L.sizeAuto || '', { N: slots.length })));
          }
          elLadder.innerHTML = parts.join(' ');
          elLadder.style.display = parts.length ? '' : 'none';
        }
      }

      function renderSizes() {
        if (!elSizes || !FRAME_MODE) return;
        var order = sizeEntries(), act = activeSize(), rec = recommendedSize(), n = slots.length;
        var base = order.length ? apiNum(priceKeyOf(order[0].key)) : null;
        var html = '';
        for (var i = 0; i < order.length; i++) {
          var s = order[i].key, price = apiNum(priceKeyOf(s)) || 0, up = base ? price - base : 0;
          var vertical = Number(s.split('x')[0]) < Number(s.split('x')[1]);
          var square = Number(s.split('x')[0]) === Number(s.split('x')[1]);
          var w = square ? 56 : (vertical ? 44 : 62), h = square ? 56 : (vertical ? 62 : 44);
          var img = L.frameImages && L.frameImages[s];
          var oos = !frameInStock(s, wiz.fcolor);
          html += '<button type="button" class="socd__size-' + UID + '' + (act === s ? ' is-on' : '') +
                  ((order[i].max < n || oos) ? ' is-tight' : '') + '" data-socd-size="' + s + '">';
          if (s === rec && !oos) html += '<span class="socd__sizerec-' + UID + '">' + esc(L.rec || '') + '</span>';
          /* Реальний рендер рамки з assets; якщо асета немає — CSS-прямокутник
             правильної пропорції, як у пікері конструктора. */
          html += '<div class="socd__sizeph-' + UID + '">' +
                  (img ? '<img src="' + esc(img) + '" alt="" onerror="this.outerHTML=\'<span style=&quot;display:block;width:' + w + 'px;height:' + h + 'px;border:3px solid #2b2b2b;border-radius:3px;background:#f4f4f6&quot;></span>\'">'
                       : '<span style="display:block;width:' + w + 'px;height:' + h + 'px;border:3px solid #2b2b2b;border-radius:3px;background:#f4f4f6"></span>') +
                  '</div>';
          html += '<div class="socd__sizenm-' + UID + '">' + esc(s.replace('x', '×')) + ' ' + esc(SOC2_LANG === 'uk' || SOC2_LANG === 'ru' ? 'см' : 'cm') + '</div>';
          html += '<div class="socd__sizemx-' + UID + '">' + esc(tpl(L.sizeMax || '', { N: order[i].max })) + '</div>';
          if (oos) html += '<div class="socd__sizeup-' + UID + '" style="color:#b45309">' + esc(L.oos || '') + '</div>';
          else html += '<div class="socd__sizeup-' + UID + '"' + (up > 0 ? '' : ' style="color:#b6b6c2"') + '>' +
                  (up > 0 ? '+' + money(up) : esc(L.sizeBase || '')) + '</div>';
          html += '</button>';
        }
        elSizes.innerHTML = html;

        var szMax = sizeMax(act);
        if (elSizeWarn) {
          if (act && szMax < n) {
            elSizeWarn.innerHTML = tpl(L.sizeWarn || '', { M: szMax, N: n });
            elSizeWarn.style.display = '';
          } else if (act && !frameInStock(act, wiz.fcolor)) {
            elSizeWarn.innerHTML = tpl(L.oosWarn || '', { S: act.replace('x', '×') });
            elSizeWarn.style.display = '';
          } else elSizeWarn.style.display = 'none';
        }
        var hint = overlay.querySelector('[data-socd-size-hint]');
        if (hint) hint.textContent = sizeTouched
          ? tpl(L.sizeManual || '', { N: n, S: (rec || '').replace('x', '×') })
          : tpl(L.sizeAuto || '', { N: n });
      }

      /* Значення дедлайну лишаються тими самими (rush/free/date/relax) — їх
         whitelist-ять обидва парсери брифу (склад TS + kickflip Python). */
      function renderDeadline() {
        if (!elDl) return;
        var c = computeDates(), now = new Date();
        var tom = new Date(now.getTime()); tom.setDate(tom.getDate() + 1);
        var rushTxt = fmtD(c.rush) === fmtD(now) ? (L.today || '')
                    : fmtD(c.rush) === fmtD(tom) ? (L.tomorrow || '') + ', ' + fmtD(c.rush)
                    : fmtD(c.rush);
        var fee = expressFee(totals().total);
        var rows = [
          { v: 'rush',  nm: L.dlRush || '',  sub: L.dlRushS || '',  date: rushTxt, tag: (L.tagPay || '') + money(fee), tagCls: 'is-pay' },
          { v: 'free',  nm: L.dlStd || '',   sub: L.dlStdS || '',   date: stdRange(), tag: L.tagFree || '', tagCls: 'is-free' },
          { v: 'date',  nm: L.dlDate || '',  sub: L.dlDateS || '',  date: L.dlDatePick || '', tag: '', tagCls: '' },
          { v: 'relax', nm: L.dlRelax || '', sub: L.dlRelaxS || '', date: (L.until || '') + ' ' + fmtD(c.relaxMax), tag: L.tagGift || '', tagCls: 'is-gift' }
        ];
        var html = '';
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i];
          html += '<button type="button" class="socd__opt-' + UID + '' + (picked.deadline === r.v ? ' is-on' : '') +
                  '" data-socd-dlval="' + r.v + '"><div class="socd__optrow-' + UID + '">' +
                  '<span class="socd__optnm-' + UID + '">' + esc(r.nm) + '</span>' +
                  (r.tag ? '<span class="socd__tag-' + UID + ' ' + r.tagCls + '">' + esc(r.tag) + '</span>' : '') +
                  '<span class="socd__optdate-' + UID + '">' + esc(r.date) + '</span></div>' +
                  '<div class="socd__optsub-' + UID + '">' + esc(r.sub) + '</div></button>';
        }
        elDl.innerHTML = html;
        renderDlNote();
      }
      function dateIsRush() {
        if (!dateInput || !dateInput.value) return false;
        var c = computeDates();
        return new Date(dateInput.value) < new Date(c.stdFrom.toDateString());
      }
      function renderDlNote() {
        if (!elDlNote) return;
        var c = computeDates(), fee = money(expressFee(totals().total)), html = '', cls = '';
        if (picked.deadline === 'rush') { html = tpl(L.noteRush || '', { F: fee }); cls = 'is-rush'; }
        else if (picked.deadline === 'free') { html = tpl(L.noteStd || '', { D: stdRange() }); cls = 'is-std'; }
        else if (picked.deadline === 'relax') { html = tpl(L.noteRelax || '', { D: fmtD(c.relaxMax) }); cls = 'is-relax'; }
        else if (picked.deadline === 'date' && dateInput && dateInput.value) {
          if (dateIsRush()) { html = tpl(L.noteDateRush || '', { F: fee, D: stdRange() }); cls = 'is-rush'; }
          else { html = tpl(L.noteDateOk || '', { D: fmtD(new Date(dateInput.value)) }); cls = 'is-std'; }
        }
        elDlNote.className = 'socd__dnote-' + UID + ' ' + cls;
        elDlNote.innerHTML = html;
        elDlNote.style.display = html ? '' : 'none';
      }

      function composeText() {
        var c = {}, out = [], i;
        for (i = 0; i < slots.length; i++) c[slots[i]] = (c[slots[i]] || 0) + 1;
        for (var k in c) if (c.hasOwnProperty(k)) out.push(c[k] + ' × ' + typeLabel(k));
        return out.join(', ');
      }
      function occText() {
        if (picked.occasion === '__other') return (wiz.occOther || '').trim();
        return picked.occasion || '';
      }
      function swLabel(group, val) {
        var b = overlay.querySelector('[data-socd-group2="' + group + '"] [data-socd-val="' + val + '"]');
        return b ? (b.getAttribute('data-socd-label') || val) : val;
      }
      function bgText() {
        if (!wiz.bg) return '';
        var lbl = swLabel('bg', wiz.bg);
        if (wiz.bg === 'idea' && (wiz.bgIdea || '').trim()) return lbl + ': ' + wiz.bgIdea.trim();
        return lbl;
      }

      function renderSummary() {
        if (!elSummary) return;
        var t = totals(), rows = [];
        rows.push([L.sumCompose || '', composeText()]);
        if (FRAME_MODE) {
          var sz = activeSize();
          rows.push([L.sumFrame || '', (sz ? sz.replace('x', '×') + (SOC2_LANG === 'uk' || SOC2_LANG === 'ru' ? ' см, ' : ' cm, ') : '') + swLabel('fcolor', wiz.fcolor)]);
          if (bgText()) rows.push([L.sumBg || '', bgText()]);
          rows.push([L.sumBrick || '', swLabel('brick', wiz.brick)]);
        } else if (picked.keychainLabel) {
          rows.push([L.keychain || '', picked.keychainLabel]);
        }
        rows.push([L.deadline || '', deadlineText()]);
        if (occText()) rows.push([L.occasion || '', occText()]);
        if (signEl && signEl.value.trim()) rows.push([L.propSign || '', signEl.value.trim()]);
        if (wishesEl && wishesEl.value.trim()) rows.push([L.wishes || '', wishesEl.value.trim().slice(0, 60)]);
        if (picked.channel) rows.push([L.channel || '', picked.channel]);
        if (t.save > 0) rows.push([L.sumDisc || '', '−' + money(t.save)]);
        var html = '';
        for (var i = 0; i < rows.length; i++) {
          html += '<div class="socd__sumline-' + UID + '"><span class="socd__sumk-' + UID + '">' + esc(rows[i][0]) +
                  '</span><span class="socd__sumv-' + UID + '">' + esc(rows[i][1]) + '</span></div>';
        }
        elSummary.innerHTML = html;
      }

      /* Людський текст дедлайну — він же їде у properties, тому містить дати. */
      function deadlineText() {
        var c = computeDates();
        if (picked.deadline === 'rush') return (L.dlRush || '') + ' — ' + (fmtD(c.rush) === fmtD(new Date()) ? (L.today || '') : fmtD(c.rush));
        if (picked.deadline === 'free') return (L.dlStd || '') + ' — ' + stdRange();
        if (picked.deadline === 'date') return (L.dlDate || '') + ': ' + ((dateInput && dateInput.value) || '');
        if (picked.deadline === 'relax') return (L.dlRelax || '') + ' (' + (L.until || '') + ' ' + fmtD(c.relaxMax) + ')';
        return '';
      }

      function renderTotal() {
        var el = overlay.querySelector('[data-socd-total]');
        var old = overlay.querySelector('[data-socd-total-old]');
        var sub = overlay.querySelector('[data-socd-total-sub]');
        var note = overlay.querySelector('[data-socd-qty-note]');
        if (!el) return;
        var t = totals();
        if (!framePrices) {
          /* Фолбек — рядок із налаштувань («od 260 zł»), теж набраний у злотих. */
          var pf = picked.price || '…';
          el.textContent = BPC && BPC.active ? BPC.text(pf) : pf;
          return;
        }
        el.textContent = money(t.total);
        if (old) old.textContent = t.save > 0 ? money(t.full) : '';
        var isRush = picked.deadline === 'rush' || (picked.deadline === 'date' && dateIsRush());
        if (sub) sub.textContent = isRush ? tpl(L.expressNote || '', { F: money(expressFee(t.total)) }) : '';
        if (note) note.style.display = 'none';
        renderBreakdown();
      }

      /* «Склад ціни» під ⓘ — ті самі числа, що в totals(), розписані по
         рядках: рамка за розміром, кожен тип × кількість, знижка, разом. */
      function renderBreakdown() {
        var box = overlay.querySelector('[data-socd-brk]');
        if (!box || !framePrices) return;
        var t = totals(), rows = [], i;
        if (FRAME_MODE && activeSize()) {
          rows.push([(L.sumFrame || 'Frame') + ' ' + activeSize().replace('x', '×'), money(t.frame)]);
        }
        var counts = {}, order = [];
        for (i = 0; i < slots.length; i++) {
          if (!counts[slots[i]]) { counts[slots[i]] = 0; order.push(slots[i]); }
          counts[slots[i]]++;
        }
        for (i = 0; i < order.length; i++) {
          var tp = order[i], p = typePrice(tp) || 0;
          rows.push([counts[tp] + ' × ' + typeLabel(tp), money(p * counts[tp])]);
        }
        var html = '<div class="socd__brkt-' + UID + '">' + esc(L.brkTitle || '') + '</div>';
        for (i = 0; i < rows.length; i++) {
          html += '<div class="socd__brkr-' + UID + '"><span>' + esc(rows[i][0]) + '</span><b>' + rows[i][1] + '</b></div>';
        }
        if (t.save > 0) {
          html += '<div class="socd__brkr-' + UID + ' is-disc"><span>' + esc(L.sumDisc || '') + '</span><b>−' + money(t.save) + '</b></div>';
        }
        html += '<div class="socd__brkr-' + UID + ' is-total"><span>' + esc(L.brkTotal || '') + '</span><b>' + money(t.total) + '</b></div>';
        /* Складові конвертуються порядково, а Shopify округлює підсумок
           варіанта — рядки НЕ зобовʼязані сходитись копійка в копійку.
           Той самий продакт-рішень, що в поповері блока ціни (2026-08-03). */
        if (BPC && BPC.active && L.convNote) {
          html += '<div class="socd__brkn-' + UID + '">' + esc(L.convNote) + '</div>';
        }
        box.innerHTML = html;
      }

      function renderNav() {
        if (elProg) {
          var h = '';
          var nTot = GROUPS ? GROUPS.length : PANES.length, nCur = scrIdx(cur_);
          for (var i = 0; i < nTot; i++) h += '<i class="' + (i <= nCur ? 'is-done' : '') + '"></i>';
          elProg.innerHTML = h;
        }
        if (elStepNo) elStepNo.innerHTML = esc(L.stepWord || '') + ' <b>' + (scrIdx(cur_) + 1) + '</b> ' + esc(L.stepOf || '') + ' <b>' + (GROUPS ? GROUPS.length : PANES.length) + '</b>';
        if (elStepNm) elStepNm.textContent = PANE_NAME[pane()] || '';
        if (prevBtn) prevBtn.style.visibility = cur_ > 0 ? 'visible' : 'hidden';
        if (nextBtn) {
          nextBtn.textContent = isLast() ? (L.submit || '') : (L.next || '');
          /* offer_mode: кнопка не «мертва» — сіра, але клікабельна: по кліку показуємо, чого бракує. */
          if (GROUPS) { nextBtn.removeAttribute('disabled'); nextBtn.classList.toggle('is-off', !paneValid()); }
          else if (paneValid()) nextBtn.removeAttribute('disabled');
          else nextBtn.setAttribute('disabled', 'disabled');
        }
        if (skipBtn) skipBtn.style.display = (pane() === 'occasion') ? '' : 'none';
        /* Гарантія — на дедлайні (де вона знімає страх «а якщо не встигнуть»)
           і на фіналі (де людина тисне «Додати в кошик»). На решті кроків вона
           лише розтягувала скрол. */
        var guar = overlay.querySelector('[data-socd-guar]');
        if (guar) guar.style.display = (pane() === 'deadline' || isLast()) ? '' : 'none';
        /* Приписка про оплату/чергу — так само лише там, де вона доречна. */
        var fine = overlay.querySelector('[data-socd-fine]');
        if (fine) fine.style.display = (pane() === 'deadline' || isLast()) ? '' : 'none';
        if (elCrumbs) {
          var html = '';
          for (var j = 0; j < scr(cur_)[0]; j++) {
            var txt = crumbText(PANES[j]);
            if (!txt) continue;
            html += '<button type="button" class="socd__crumb-' + UID + '" data-socd-goto="' + j + '">' + esc(txt) + ' <span>✎</span></button>';
          }
          elCrumbs.innerHTML = html;
        }
      }
      function crumbText(p) {
        if (p === 'compose') {
          var c = {}, out = [], i;
          for (i = 0; i < slots.length; i++) c[slots[i]] = (c[slots[i]] || 0) + 1;
          for (var k in c) if (c.hasOwnProperty(k)) out.push(TYPE_EMOJI[k] + ' ' + c[k]);
          return out.join(' + ');
        }
        if (p === 'format') return picked.keychainLabel || '';
        if (p === 'frame') { var s = activeSize(); return '🖼️ ' + (s ? s.replace('x', '×') : '') + ' · ' + swLabel('fcolor', wiz.fcolor); }
        if (p === 'bg') return bgText() ? '🎨 ' + bgText().slice(0, 26) : '';
        if (p === 'deadline') return deadlineText().slice(0, 34);
        if (p === 'occasion') return occText();
        return '';
      }
      function paneValid(pp) {
        if (GROUPS && !pp) {
          var sc = scr(cur_);
          for (var si = 0; si < sc.length; si++) if (!paneValid(PANES[sc[si]])) return false;
          return true;
        }
        var p = pp || pane();
        if (p === 'compose') return slots.length > 0;
        if (p === 'format') return !!picked.keychain;
        if (p === 'frame') {
          var s = activeSize();
          return !!s && sizeMax(s) >= slots.length && frameInStock(s, wiz.fcolor);
        }
        if (p === 'bg') return !!wiz.bg;
        if (p === 'deadline') return !!picked.deadline && (picked.deadline !== 'date' || !!(dateInput && dateInput.value));
        if (p === 'occasion') return true;
        if (p === 'contact') {
          /* У заявці контакт обовʼязковий — саме туди полетить макет. */
          if (REQUEST_MODE) return !!picked.channel && !!(REQX && REQX.validContact && REQX.validContact());
          return !!picked.channel;
        }
        return true;
      }
      function showPane() {
        var list = overlay.querySelectorAll('[data-socd-w]');
        var sc = scr(cur_);
        for (var i = 0; i < list.length; i++) list[i].classList.toggle('is-active', sc.indexOf(i) >= 0);
        var modal = overlay.querySelector('.socd__modal-' + UID);
        if (modal) modal.scrollTop = 0;
        /* на мобільному скролер — сам оверлей */
        overlay.scrollTop = 0;
      }
      function renderAll() {
        renderFacts();
        renderSlots();
        renderSizes();
        renderDeadline();
        renderTotal();
        if (isLast()) renderSummary();
        renderNav();
      }
      function goto_(i) {
        cur_ = Math.max(0, Math.min(PANES.length - 1, i));
        if (GROUPS) cur_ = scr(cur_)[0];
        showPane(); renderAll();
      }

      var lastFocus = null;

      /* The overlay is moved to <body> so no ancestor transform/overflow can trap it. */
      function ensureAtBody() {
        if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      }

      function pickDefaults() {
        var groups = overlay.querySelectorAll('[data-socd-group]');
        for (var i = 0; i < groups.length; i++) {
          var g = groups[i].getAttribute('data-socd-group');
          /* Keychain preselects the FIRST chip = "with keychain". Unlike
             "occasion" this is not a guess: the chain is listed in what the
             set includes, so with-keychain is what the customer is already
             buying. "Occasion" stays blank on purpose: guessing it would put
             invented data into the designer's brief. */
          if (g === 'channel' || g === 'keychain') {
            var first = groups[i].querySelector('.socd__chip-' + UID);
            if (first && !groups[i].querySelector('.is-on')) first.click();
          }
        }
        /* Preselect the STANDARD lead time, never "urgent" — the form must not
           promise urgency (and a paid express item) on the customer's behalf. */
        if (!picked.deadline) {
          picked.deadline = 'free';
          picked.deadlineLabel = L.dlStd || '';
        }
        /* Background: the designer picking it is the default we actually want —
           it is the answer that needs no thinking and no typing. */
        if (FRAME_MODE && !wiz.bg) {
          wiz.bg = 'designer';
          var bgb = overlay.querySelector('[data-socd-group2="bg"] [data-socd-val="designer"]');
          if (bgb) bgb.classList.add('is-on');
        }
        markSwatch('fcolor', wiz.fcolor);
        markSwatch('brick', wiz.brick);
        syncSlotsFromCards();
      }
      function markSwatch(group, val) {
        var box = overlay.querySelector('[data-socd-group2="' + group + '"]');
        if (!box) return;
        var bs = box.children;
        for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('is-on', bs[i].getAttribute('data-socd-val') === val);
      }
      /* The cards above the CTA already asked "how many" — carry that over so
         the popup never contradicts what the customer just tapped. */
      function syncSlotsFromCards() {
        if (FRAME_MODE || slotsTouched) return;
        var sel = root.querySelector('.soc2__card-' + UID + '.is-selected') ||
                  root.querySelector('[data-soc2-card][aria-checked="true"]');
        var n = sel && Number(sel.getAttribute('data-soc2-figure-count') || sel.getAttribute('data-soc2-card'));
        if (!n) n = Number(root.getAttribute('data-socd-qty')) || 0;
        if (!n || n < 1 || n > 12) return;
        slots = [];
        for (var i = 0; i < n; i++) slots.push('human');
      }
      var slotsTouched = false;

      overlay.addEventListener('click', function (e) {
        var chip = e.target.closest ? e.target.closest('.socd__chip-' + UID) : null;
        if (chip && overlay.contains(chip)) {
          var box = chip.parentNode;
          var group = box.getAttribute('data-socd-group');
          var siblings = box.querySelectorAll('.socd__chip-' + UID);
          for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-on');
          chip.classList.add('is-on');

          var val = chip.getAttribute('data-socd-val');
          if (group === 'keychain') {
            picked.keychain = val;
            picked.keychainLabel = chip.getAttribute('data-socd-label') || val;
          } else if (group === 'occasion') {
            /* «Інше» — не привід, а запрошення написати свій. Повторний тап
               по вже обраному чіпу знімає вибір: крок необовʼязковий. */
            if (picked.occasion === val) { picked.occasion = ''; chip.classList.remove('is-on'); }
            else picked.occasion = val;
            if (occOtherEl) {
              var showOther = picked.occasion === '__other';
              occOtherEl.style.display = showOther ? '' : 'none';
              if (showOther) setTimeout(function () { occOtherEl.focus(); }, 60);
            }
          } else if (group === 'channel') {
            picked.channel = val;
          }
          if (errEl) errEl.classList.remove('is-on');
          /* renderAll, а не renderNav: на останньому кроці під чіпами стоїть
             підсумок замовлення, і без перемальовки він показував би канал
             звʼязку, обраний за замовчуванням, а не щойно натиснутий. */
          renderAll();
          return;
        }

        /* ── wizard controls ───────────────────────────────────────────────── */
        var t = e.target;
        var hit = function (sel) { return t.closest ? t.closest(sel) : null; };

        var rm = hit('[data-socd-slotrm]');
        if (rm && overlay.contains(rm)) {
          slots.splice(Number(rm.getAttribute('data-socd-slotrm')), 1);
          slotsTouched = true; renderAll(); return;
        }
        var set = hit('[data-socd-slotset]');
        if (set && overlay.contains(set)) {
          var parts = set.getAttribute('data-socd-slotset').split('|');
          slots[Number(parts[0])] = parts[1];
          slotsTouched = true; renderAll(); return;
        }
        if (elAddSlot && hit('[data-socd-addslot]') && !elAddSlot.hasAttribute('disabled')) {
          slots.push('human'); slotsTouched = true; renderAll(); return;
        }
        var sz = hit('[data-socd-size]');
        if (sz && overlay.contains(sz)) {
          picked.size = sz.getAttribute('data-socd-size');
          picked.sizeLabel = picked.size.replace('x', '×');
          sizeTouched = true; renderAll(); return;
        }
        var dl = hit('[data-socd-dlval]');
        if (dl && overlay.contains(dl)) {
          picked.deadline = dl.getAttribute('data-socd-dlval');
          picked.deadlineLabel = deadlineText();
          if (dateInput) {
            dateInput.style.display = (picked.deadline === 'date') ? '' : 'none';
            if (picked.deadline === 'date') setTimeout(function () { dateInput.focus(); }, 60);
          }
          renderAll(); return;
        }
        var sw = hit('[data-socd-group2] [data-socd-val]');
        if (sw && overlay.contains(sw)) {
          var grp = sw.parentNode.getAttribute('data-socd-group2');
          var v2 = sw.getAttribute('data-socd-val');
          if (grp === 'fcolor') { wiz.fcolor = v2; fcolorTouched = true; }
          else if (grp === 'brick') wiz.brick = v2;
          else if (grp === 'bg') {
            wiz.bg = v2;
            if (bgIdeaEl) {
              bgIdeaEl.style.display = (v2 === 'idea') ? '' : 'none';
              if (v2 === 'idea') setTimeout(function () { bgIdeaEl.focus(); }, 60);
            }
          }
          markSwatch(grp, v2);
          renderAll(); return;
        }
        var crumb = hit('[data-socd-goto]');
        if (crumb && overlay.contains(crumb)) { goto_(Number(crumb.getAttribute('data-socd-goto'))); return; }

        /* ⓘ «Склад ціни»: тап по значку — перемкнути, тап будь-де інде — сховати. */
        var brkBox = overlay.querySelector('[data-socd-brk]');
        if (hit('[data-socd-brk-toggle]')) {
          if (brkBox) brkBox.style.display = (brkBox.style.display === 'none') ? '' : 'none';
          return;
        }
        if (brkBox && brkBox.style.display !== 'none' && !hit('[data-socd-brk]')) {
          brkBox.style.display = 'none';
        }

        if (e.target === overlay || (e.target.closest && e.target.closest('[data-socd-close]'))) close();
      });

      /* offer_mode: підсвітити незаповнене на поточному екрані й прокрутити до першого. */
      var MISS_TXT = ({ uk: 'Заповніть позначені поля', ru: 'Заполните отмеченные поля', pl: 'Uzupełnij zaznaczone pola', en: 'Fill in the highlighted fields', it: 'Compila i campi evidenziati', de: 'Füll die markierten Felder aus', cs: 'Vyplňte označená pole', es: 'Rellena los campos marcados', fr: 'Remplissez les champs indiqués', nl: 'Vul de gemarkeerde velden in', sk: 'Vyplňte označené polia', hu: 'Töltsd ki a megjelölt mezőket', ro: 'Completează câmpurile marcate', lt: 'Užpildykite pažymėtus laukus', lv: 'Aizpildi atzīmētos laukus', et: 'Täida märgitud väljad' })[(document.documentElement.lang || 'uk').slice(0, 2)] || 'Fill in the highlighted fields';
      function flagMissing() {
        var panesEl = overlay.querySelectorAll('[data-socd-w]'), sc = scr(cur_), bad = [];
        var mailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        sc.forEach(function (i) {
          var p = PANES[i], el = panesEl[i];
          if (!el || paneValid(p)) return;
          var mine = [];
          if (p === 'contact') {
            var hasPhone = !!el.querySelector('[data-socd-contact-phone]');
            var q = function (s) { var x = el.querySelector(s); return x && x.offsetParent !== null ? x : null; };
            var nm = q('[data-socd-contact-name]'), ph = q('[data-socd-contact-phone]'), cv = q('[data-socd-contact-val]'), em = q('[data-socd-contact-email]');
            if (nm && !nm.value.trim()) mine.push(nm);
            if (ph && ph.value.replace(/\D/g, '').length < 10) mine.push(ph);
            if (cv && !hasPhone && !cv.value.trim()) mine.push(cv);
            if (em) { var v = em.value.trim(); if (hasPhone ? (v !== '' && !mailRe.test(v)) : !mailRe.test(v)) mine.push(em); }
            var cs = el.querySelector('[data-socd-consent]');
            if (cs && !cs.checked) mine.push(cs.closest('label') || cs);
          }
          if (!mine.length) mine.push(el);
          bad = bad.concat(mine);
        });
        bad.forEach(function (b) { b.classList.remove('po-miss'); void b.offsetWidth; b.classList.add('po-miss'); });
        setTimeout(function () { bad.forEach(function (b) { b.classList.remove('po-miss'); }); }, 3000);
        if (bad[0] && bad[0].scrollIntoView) bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        var msg = overlay.querySelector('[data-po-miss-msg]');
        if (!msg && nextBtn.parentNode) {
          msg = document.createElement('div'); msg.setAttribute('data-po-miss-msg', '');
          msg.style.cssText = 'width:100%;text-align:center;font-size:13px;font-weight:700;color:#dc2626;margin:0 0 6px';
          nextBtn.parentNode.parentNode.insertBefore(msg, nextBtn.parentNode);
        }
        if (msg) { msg.textContent = MISS_TXT; msg.hidden = false; clearTimeout(flagMissing._t); flagMissing._t = setTimeout(function () { msg.hidden = true; }, 3500); }
      }
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (!paneValid()) { if (GROUPS) flagMissing(); return; }
        if (isLast()) { doSubmit(); return; }
        goto_(stepTo(1));
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { goto_(stepTo(-1)); });
      if (skipBtn) skipBtn.addEventListener('click', function () { if (!isLast()) goto_(stepTo(1)); });
      if (dateInput) dateInput.addEventListener('change', function () {
        picked.deadlineLabel = deadlineText();
        renderAll();
      });
      if (bgIdeaEl) bgIdeaEl.addEventListener('input', function () { wiz.bgIdea = bgIdeaEl.value; });
      if (occOtherEl) occOtherEl.addEventListener('input', function () { wiz.occOther = occOtherEl.value; });

      function open(step) {
        ensureAtBody();
        lastFocus = document.activeElement;
        overlay.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        pickDefaults();
        /* Три API тягнемо при відкритті: ціни й наявність типів — з прайсу
           магазину, дати — з графіка складу, активні розміри рамок — з
           каталогу «⚙️ Рамки». Поки не відповіли, візард живий і показує «…»
           замість суми, а не порожній екран. */
        fetchFramePrices();
        fetchDelivery();
        fetchBgCatalog();
        fetchInventory();
        cur_ = 0;
        showPane();
        renderAll();
        var first = step || (LAYOUT === 'choice_popup' ? 'choice' : 'brief');
        showStep(first);
        if (first === 'choice') { forkOpens++; track('Fork_View'); }
      }
      function close() {
        if (curStep === 'choice' && overlay.classList.contains('is-open')) track('Fork_Close');
        overlay.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      if (LAYOUT === 'two_buttons') {
        openBtn.addEventListener('click', function () { open('brief'); });
      } else {
        /* One button: the primary CTA opens the choice screen instead of
           navigating. Its href is still maintained by the card logic above,
           so "open the builder" keeps the ?qty=N the customer selected. */
        ctaLink.addEventListener('click', function (e) {
          e.preventDefault();
          open('choice');
        });
        /* offer_mode: «Хочу зібрати сам» — одразу в конструктор, повз розвилку,
           з тим самим ?qty=N, що й у головної кнопки. */
        var directLink = root.querySelector('[data-socd-direct]');
        if (directLink) {
          directLink.addEventListener('click', function (e) {
            e.preventDefault();
            var href = ctaLink.getAttribute('href') || directLink.getAttribute('href') || '/';
            track('Fork_Direct');
            setTimeout(function () { window.location.href = href; }, 150);
          });
        }
        overlay.addEventListener('click', function (e) {
          var path = e.target.closest ? e.target.closest('[data-socd-go]') : null;
          if (!path || !overlay.contains(path)) return;
          if (path.getAttribute('data-socd-go') === 'self') {
            track('Fork_Kreator');
            /* Коротка пауза, щоб запит пікселя встиг піти до переходу. */
            var href = ctaLink.getAttribute('href') || '/';
            setTimeout(function () { window.location.href = href; }, 150);
          } else {
            track('Fork_Projektant');
            showStep('brief');
          }
        });
        overlay.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          var path = e.target.closest ? e.target.closest('[data-socd-go]') : null;
          if (path) { e.preventDefault(); path.click(); }
        });
        var backBtn = overlay.querySelector('[data-socd-back]');
        if (backBtn) backBtn.addEventListener('click', function () { showStep('choice'); });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
      });

      var spinEl  = overlay.querySelector('[data-socd-spin]');
      var labelEl = overlay.querySelector('[data-socd-submit-label]');
      var labelIdle = labelEl ? labelEl.textContent : '';

      /* Busy state. The variant lookup can take seconds on a cold backend —
         a dimmed button with no motion reads as "broken", so say what is
         happening and keep something moving. */
      function setBusy(on) {
        if (spinEl) spinEl.hidden = !on;
        if (labelEl) labelEl.textContent = on ? (L.submitting || labelIdle) : labelIdle;
        /* Кнопка, яку людина реально натиснула, — це «Далі/Додати в кошик»
           візарда; сам submitBtn прихований і лишився носієм налаштувань. */
        var btn = nextBtn || submitBtn;
        if (on) {
          btn.setAttribute('disabled', 'disabled');
          if (btn === nextBtn) btn.textContent = L.submitting || (L.submit || '');
        } else {
          btn.removeAttribute('disabled');
          if (btn === nextBtn) btn.textContent = L.submit || '';
        }
        btn.setAttribute('aria-busy', on ? 'true' : 'false');
      }

      function fail() {
        if (errEl) errEl.classList.add('is-on');
        setBusy(false);
      }

      /* Короткі 502 бекенда повторюємо мовчки, людині кажемо лише як не вийшло
         ЖОДНОГО разу. Лукап ідемпотентний — ретраїти вільно; cart/add ретраїмо
         ТІЛЬКИ на мережевій/5xx (на 4xx повтор ризикує дублем позиції). */
      function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

      async function withRetry(label, attempts, fn) {
        var lastErr;
        for (var i = 0; i < attempts; i++) {
          /* Наростаючі паузи (разом ~10с на 5 спроб): свіжостворений
             variant-by-price варіант Shopify інколи віддає як «already
             sold out» довше за 2-3с — коротка драбинка не встигала
             (рамка 3662 грн, серпень 2026). */
          if (i > 0) await sleep([700, 1500, 3000, 5000][i - 1] || 5000);
          try {
            return await fn();
          } catch (e) {
            lastErr = e;
            if (e && e.__noRetry) break;
          }
        }
        var err = lastErr instanceof Error ? lastErr : new Error(String(lastErr));
        err.__stage = label;
        throw err;
      }

      /* Останній рубіж: усі спроби провалились. Склад перешле це в Telegram —
         інакше про такі збої ми дізнаємось тільки з падіння виторгу. */
      function reportFailure(err) {
        var url = submitBtn.getAttribute('data-socd-report-url');
        if (!url) return;
        try {
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,            /* щоб долетіло, навіть якщо сторінку закриють */
            body: JSON.stringify({
              stage: (err && err.__stage) || 'unknown',
              store: submitBtn.getAttribute('data-socd-store') || '',
              message: String((err && err.message) || err || '').slice(0, 300),
              url: location.href.slice(0, 300)
            })
          }).catch(function () { /* репорт — best effort, покупцю це не показуємо */ });
        } catch (e) { /* ignore */ }
      }

      /* Який варіант продавати: 1) явний per-card variant ID; 2) інакше
         find-or-create за ЦІНОЮ картки (той самий ендпоінт конструктора);
         3) фолбек на варіант товару лише без ціни взагалі. Невдалий лукап =
         помилка, не фолбек: тиха неправильна ціна гірша за відмову. */
      function variantForPrice(price, productType) {
        var api = submitBtn.getAttribute('data-socd-variant-api');
        if (!api || !(price > 0)) return Promise.reject(new Error('no price, no variant'));
        return withRetry('variant', 3, function () {
          return fetch(api, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ price: price, productType: productType })
          })
            .then(function (r) {
              if (r.ok) return r.json();
              /* Бекенд кладе причину в body.error — тягнемо її в алерт. */
              return r.json().catch(function () { return {}; }).then(function (b) {
                var detail = b && (b.error || b.message);
                return Promise.reject(new Error('HTTP ' + r.status + (detail ? ' — ' + String(detail).slice(0, 180) : '')));
              });
            })
            .then(function (d) {
              var gid = d && d.variant && d.variant.id;
              if (!d.success || !gid) return Promise.reject(new Error('no variant'));
              return Number(String(gid).split('/').pop());
            });
        });
      }

      /* Frame — ONE line (size+figures → one variant). Set — ONE LINE PER TYPE
         (qty=count), як бандл конструктора, інакше автоматична знижка Shopify
         не спрацює (2 людини + 1 звір = 2×figure + 1×animal, не 3×figure).
         Бриф — ТІЛЬКИ на першій лінії (дубль = склад бачить замовлення
         кілька разів); решта несуть _bt_designer для виключення списання. */
      function cartLines(props) {
        if (FRAME_MODE) {
          var ft = totals().total;
          if (!(ft > 0)) return Promise.reject(new Error('frame price unavailable'));
          if (picked.variant) return Promise.resolve([{ id: Number(picked.variant), quantity: 1, properties: props }]);
          return variantForPrice(ft, submitBtn.getAttribute('data-socd-product-type') || 'frame')
            .then(function (id) { return [{ id: id, quantity: 1, properties: props }]; });
        }

        var counts = {}, order = [], i;
        for (i = 0; i < slots.length; i++) {
          if (!counts[slots[i]]) { counts[slots[i]] = 0; order.push(slots[i]); }
          counts[slots[i]]++;
        }
        /* Прайс не відповів — відкочуємось на ціну картки й одну позицію:
           замовлення пройде за рекламованою сумою, покупець не втратить. */
        if (!framePrices) {
          var priceTxt = picked.price || submitBtn.getAttribute('data-socd-price') || '';
          var p = parsePriceText(priceTxt);
          if (!(p > 0)) {
            var fb = submitBtn.getAttribute('data-socd-variant');
            if (!fb) return Promise.reject(new Error('no price, no variant'));
            return Promise.resolve([{ id: Number(fb), quantity: 1, properties: props }]);
          }
          return variantForPrice(p, submitBtn.getAttribute('data-socd-product-type') || 'mini')
            .then(function (id) { return [{ id: id, quantity: 1, properties: props }]; });
        }

        var ptype = submitBtn.getAttribute('data-socd-product-type') || 'mini';
        var jobs = order.map(function (t) {
          var price = typePrice(t);
          if (!(price > 0)) return Promise.reject(new Error('no price for ' + t));
          /* Тваринка — окремий тип товару в бекенді, у неї свій прайс і свій SKU. */
          return variantForPrice(price, t === 'animal' ? 'pet' : ptype)
            .then(function (id) { return { id: id, quantity: counts[t], type: t }; });
        });
        return Promise.all(jobs).then(function (lines) {
          var thin = {};
          thin['_bt_designer'] = '1';
          var img = submitBtn.getAttribute('data-socd-cart-img');
          if (img) thin['_bt_designer_img'] = img;
          thin[L.mode || 'Design'] = L.modeVal || 'Designer';
          return lines.map(function (l, idx) {
            return { id: l.id, quantity: l.quantity, properties: idx === 0 ? props : thin };
          });
        });
      }

      function doSubmit() {
        /* «Оплата після макета»: заявку шле асет bt-design-request.js. */
        if (REQUEST_MODE) {
          if (window.BTDesignRequest) { window.BTDesignRequest.submit(REQX); } else { fail(); }
          return;
        }
        /* Крокова валідація вже не пускає далі без розміру/дедлайну, але
           лишаємо і тут: кнопку можна дістати програмно. */
        if (FRAME_MODE && !activeSize()) return;
        if (!picked.deadline) return;

        var composition = {}, i;
        for (i = 0; i < slots.length; i++) composition[slots[i]] = (composition[slots[i]] || 0) + 1;

        var props = {};
        props['_bt_designer'] = '1';
        /* Hidden: the cart snippet swaps the line thumbnail to this when present.
           A price-matched variant carries the generic product photo, which gives
           the customer no clue that a designer is building this one. */
        var cartImg = submitBtn.getAttribute('data-socd-cart-img');
        if (cartImg) props['_bt_designer_img'] = cartImg;
        props[L.mode || 'Design'] = L.modeVal || 'Designer';
        /* Склад друкує це як «Кількість фігурок: 2 × Людина, 1 × Тваринка» —
           дизайнеру одразу видно склад набору, а не саме лише число. */
        props[L.qty || 'Qty'] = composeText();
        /* Printed as "Тип: Брелок" / "Тип: Без брелока" — the same shape the
           constructor writes, so the cart's keychain counter reads designer
           lines too instead of ignoring them. */
        if (picked.keychainLabel) props[L.keychain || 'Type'] = picked.keychainLabel;
        if (FRAME_MODE) {
          props[L.figs || 'Figures'] = String(slots.length);
          if (activeSize()) props[L.size || 'Size'] = activeSize().replace('x', '×');
          props[L.propFcolor || 'Frame colour'] = swLabel('fcolor', wiz.fcolor);
          props[L.propBrick || 'Brick colour'] = swLabel('brick', wiz.brick);
          if (bgText()) props[L.propBg || 'Background'] = bgText();
          if (signEl && signEl.value.trim()) props[L.propSign || 'Caption'] = signEl.value.trim().slice(0, 200);
        }
        props[L.deadline || 'Deadline'] = deadlineText();
        if (occText()) props[L.occasion || 'Occasion'] = occText();
        if (wishesEl && wishesEl.value.trim()) props[L.wishes || 'Wishes'] = wishesEl.value.trim().slice(0, 900);
        if (picked.channel) props[L.channel || 'Contact'] = picked.channel;

        /* Stable machine-readable copy for the warehouse / Orders 2.0.
           ⚠⚠ Кожне НОВЕ поле треба покласти в ОБИДВА парсери, інакше воно
           мовчки зникне: sklad lib/order-sources.ts (normalizeDesignerBrief)
           і kickflip core/orders_v2_utils.py (_extract_designer_brief). */
        props['_bt_designer_brief'] = JSON.stringify({
          qty: String(slots.length),
          composition: composition,
          figures: FRAME_MODE ? String(slots.length) : null,
          size: FRAME_MODE ? activeSize() : null,
          frame_color: FRAME_MODE ? wiz.fcolor : null,
          brick_color: FRAME_MODE ? wiz.brick : null,
          background: FRAME_MODE ? (bgText() || null) : null,
          signature: (FRAME_MODE && signEl && signEl.value.trim().slice(0, 200)) || '',
          deadline: picked.deadline,
          keychain: picked.keychain ? picked.keychain === 'yes' : null,
          deadline_date: (dateInput && dateInput.value) || '',
          occasion: occText(), channel: picked.channel,
          wishes: (wishesEl && wishesEl.value.trim().slice(0, 900)) || ''
        });

        setBusy(true);
        if (errEl) errEl.classList.remove('is-on');

        cartLines(props)
          .then(function (items) {
            return withRetry('cart', 5, function () {
              return fetch(submitBtn.getAttribute('data-socd-add-url') || '/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: items })
              }).then(function (r) {
                if (r.ok) return r.json();
                /* Тіло відповіді каже, ЧОМУ Shopify відмовив («Cannot find
                   variant», «sold out») — без нього в алерті голий статус,
                   який неможливо діагностувати. Читаємо best-effort. */
                return r.json().catch(function () { return {}; }).then(function (b) {
                  var detail = b && (b.description || b.message);
                  var e = new Error('HTTP ' + r.status + (detail ? ' — ' + String(detail).slice(0, 180) : ''));
                  /* 4xx — Shopify нас зрозумів і відмовив: повтор дасть те саме.
                     Виняток — 422: свіжостворений variant-by-price варіант перші
                     секунди невідомий вітрині, і повтор із паузою проходить.
                     Дубля не буде — чистий 422 означає, що в кошик нічого не впало
                     (ризик дубля існує лише на таймауті/5xx). */
                  if (r.status < 500 && r.status !== 422) e.__noRetry = true;
                  return Promise.reject(e);
                });
              });
            });
          })
          .then(function () {
            window.location.href = submitBtn.getAttribute('data-socd-cart-url') || '/cart';
          })
          .catch(function (err) {
            reportFailure(err);
            fail();
          });
      }
      submitBtn.addEventListener('click', doSubmit);
    })();

  })();
  }
  window.BtSocdInit = init;
  var q = window.BtSocdQueue || [];
  window.BtSocdQueue = { push: function (a) { init(a[0], a[1]); } };
  for (var i = 0; i < q.length; i++) init(q[i][0], q[i][1]);
})();

